// https://v3.docs.apostrophecms.org/guide/front-end-tips.html#register-js-to-keep-up-with-in-context-editing-events
import {
  createAlerts,
  getFilters,
  saveJob,
  SAVED_JOB_CHANGE_EVENT,
  markSavedJobs,
  getUtmTrackerId,
  quickJobApplyJobDetails,
  getJobFilters,
  getSortValue
} from '../../../../lib/helpers/jobHelpers';
import { isDesktopView } from "../../../../lib/helpers/common";
// import {getFilters} from '../../../job/index';
import {
  loadPageSize,
  removeCustomPageSize,
  setCurrentPageSize,
  setPageSizeEvent
} from "../../../../lib/helpers/common";
import { logWLAnalyticsEvent } from '../../../../lib/helpers/wlAnalyticsLoggerUtil';

export default () => {
  apos.util.widgetPlayers.jobSearchSplitScreen = {
    selector: '#job-search-filters__form_splitscreen',
    player: function (searchForm) {
      if (searchForm) {
        const __t = JSON.parse(searchForm.dataset.localizedValues);
        const localePrefix = searchForm.dataset.localePrefix;

        // Select the button element
        var checkedFilters=[]
        const searchButton = document.querySelector("#btn-SeachSplitScreen");
        var QuestionnaireValidated = false;
        var alreadyReplaced=false
        var skillsUpdated=false
        var onInitialLoad=true
        var utmTrackerId = null;
        var phoneInputQuickApply = null;
        var baseUrl = "";
        var externalUrl = window.aposCustomConfig?.baseUrl;
        const containsUtmParams = window.location.search.includes('utm_source');
        if (containsUtmParams) {
          getUtmTrackerId('Job')
            .then(response => {
              utmTrackerId = response;
            });
        }
        // Add a click event listener to the button
        searchButton.addEventListener("click", function (event) {
          event.preventDefault();
          onFilterChange();
        });

        var jobDetailsTab = document.querySelectorAll(".jobDetailsTab");
        var applyNowBtn = document.querySelectorAll(".applyNowBtn");
        var applicationTab = document.querySelector(".applicationTab");
        const jobDetailsElement = document.getElementById("jobDetails");
        const mapViewElement = document.getElementById("mapView");
        const toggleMapViewButton = document.getElementById("toggleMapViewButton");
        const backToResultsBtn = document.querySelector('.back-to-results-btn');
        var largeScreen=false;
      
      const shareButton = document.querySelector('.shareButton');
      const shareModal = document.getElementById('shareModal');
      const closeButton = document.querySelector('.share-modal__close');

      shareButton?.addEventListener('click', openJobShareModl);
      closeButton?.addEventListener('click', closeModal);
      shareModal?.addEventListener('click', (e) => {
        if (e.target === shareModal) {
            closeModal();
        }
      });
      function openJobShareModl(){
        const shareModal = document.getElementById('shareModal');
        const shareButton = document.querySelector('.shareButton');
        shareModal.classList.add('active');
        shareButton.classList.add('active');
      }

      function closeModal() {
        const shareModal = document.getElementById('shareModal');
        const shareButton = document.querySelector('.shareButton');
        shareModal.classList.remove('active');
        shareButton.classList.remove('active');
      }

      const canonicalUrl = document.querySelector('link[rel="canonical"]')?.href;
      let shareUrl = '';
      if (canonicalUrl) {
        const url = new URL(canonicalUrl);
        url.pathname = '/job';
        shareUrl = url.toString();
      }

      const copyLink = document.querySelector(".copyToClipBoard");
      copyLink?.addEventListener("click", onCopyShareLink);
      async function onCopyShareLink() {
          let shareUrl = new URL(window.location.href).origin + "/job/" + document.getElementById("job-data").dataset.slug
          navigator.clipboard.writeText(shareUrl+"?utm_source=workllama_share&utm_campaign=cms&utm_medium=referral")
           .then(() => {
              alert(__t['jobDetail.copiedToClipboardMessage']);
            });
      }

       const email = document.querySelector(".email");
       email?.addEventListener("click", onEmailShareLink);
       async function onEmailShareLink() {
            let shareUrl = new URL(window.location.href).origin + "/job/" + document.getElementById("job-data").dataset.slug
            const jobTitle = data["jobTitle"];
            var emailSub = __t['jobDetail.shareLinkEmailSubject'] + jobTitle;
            var emailBody = __t['jobDetail.shareLinkEmailBody'].replace('{shareLink}',shareUrl+"?utm_source=email_share&utm_campaign=cms&utm_medium=referral");
            window.open(
              "mailto:?" +
                "&subject=" +
                encodeURIComponent(emailSub) +
                "&body=" +
                encodeURIComponent(emailBody)
            );
      }
      
      const faceBook = document.querySelector(".faceBook");
      faceBook?.addEventListener('click', onFbShareLink);
      function onFbShareLink() {
          let shareUrl = new URL(window.location.href).origin + "/job/" + document.getElementById("job-data").dataset.slug
          window.open(
            `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`,
            "_blank",
            "noopener,noreferrer"
          );
      }
      const linkedIn = document.querySelector(".linkedIn");
      linkedIn?.addEventListener("click", onLinkedInShareLink);
      async function onLinkedInShareLink() {
        let shareUrl = new URL(window.location.href).origin + "/job/" + document.getElementById("job-data").dataset.slug
        window.open(
              "https://www.linkedin.com/shareArticle?mini=true&url=" +
              encodeURIComponent(shareUrl +"?utm_source=linkedin_share&utm_campaign=cms&utm_medium=referral") +
                "&title=",
              "",
              "menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600"
        );
      }
      
      const twitter = document.querySelector(".twitter");
      twitter?.addEventListener("click", onTwitterShareLink);
      async function onTwitterShareLink() {
          let shareUrl = new URL(window.location.href).origin + "/job/" + document.getElementById("job-data").dataset.slug
          window.open(
             "https://twitter.com/share?url=" + encodeURIComponent( shareUrl +"?utm_source=x_share&utm_campaign=cms&utm_medium=referral")+ "",
              "menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600"
            );
      }

      if(mapViewElement)
          mapViewElement.style.display = "none";
        // add listener when the url change to properly hide/show jobDetails in mobile view
        window.addEventListener('popstate', function () {
          showHideJobDetails();
        });

        // base on the URL decide if show or hide job details, necessary in mobile view
        function showHideJobDetails() {
          const pageUrl = searchForm.dataset.currentPageUrl;
          const fullUrl = new URL(window.location.href);
          const urlWithoutSearch = `${fullUrl.origin}${fullUrl.pathname}`;

          // should show search view
          if (pageUrl === urlWithoutSearch) {
            hideJobDetails();
          } else {
            showJobDetails();
          }
        }

        function showJobDetails() {
          if (!isDesktopView()) {
            window.scrollTo(0, 0);
          }
          searchForm.classList.add('job-details-open');
        }

        function hideJobDetails() {
          if (!isDesktopView()) {
            window.scrollTo(0, 0);
          }
          searchForm.classList.remove('job-details-open');
        }

        function toggleMapView(action = __t['jobSearch.hideMapLabel']) {
          const jobDetailsElement = document.getElementById("jobDetails");
          const mapViewElement = document.getElementById("mapView");
          if(jobDetailsElement && mapViewElement && toggleMapViewButton){
            if (action && action.trim() === __t['jobSearch.hideMapLabel']) {
              jobDetailsElement.style.display = "block";
              mapViewElement.style.display = "none";
              toggleMapViewButton.innerHTML = "<svg xmlns=\"http://www.w3.org/2000/svg\" height=\"1em\" viewBox=\"0 0 576 512\"><!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d=\"M565.6 36.2C572.1 40.7 576 48.1 576 56V392c0 10-6.2 18.9-15.5 22.4l-168 64c-5.2 2-10.9 2.1-16.1 .3L192.5 417.5l-160 61c-7.4 2.8-15.7 1.8-22.2-2.7S0 463.9 0 456V120c0-10 6.1-18.9 15.5-22.4l168-64c5.2-2 10.9-2.1 16.1-.3L383.5 94.5l160-61c7.4-2.8 15.7-1.8 22.2 2.7zM48 136.5V421.2l120-45.7V90.8L48 136.5zM360 422.7V137.3l-144-48V374.7l144 48zm48-1.5l120-45.7V90.8L408 136.5V421.2z\"/>\n" +
                "                              </svg> " + __t['jobSearch.mapViewLabel'];
            } else {
              jobDetailsElement.style.display = "none";
              mapViewElement.style.display = "block";
              toggleMapViewButton.innerHTML = "<svg xmlns=\"http://www.w3.org/2000/svg\" height=\"1em\" viewBox=\"0 0 576 512\"><!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d=\"M565.6 36.2C572.1 40.7 576 48.1 576 56V392c0 10-6.2 18.9-15.5 22.4l-168 64c-5.2 2-10.9 2.1-16.1 .3L192.5 417.5l-160 61c-7.4 2.8-15.7 1.8-22.2-2.7S0 463.9 0 456V120c0-10 6.1-18.9 15.5-22.4l168-64c5.2-2 10.9-2.1 16.1-.3L383.5 94.5l160-61c7.4-2.8 15.7-1.8 22.2 2.7zM48 136.5V421.2l120-45.7V90.8L48 136.5zM360 422.7V137.3l-144-48V374.7l144 48zm48-1.5l120-45.7V90.8L408 136.5V421.2z\"/>\n" +
                "                              </svg> " + __t['jobSearch.hideMapLabel'];
              window.setupMapView();
            }
          }
        }

        function backToResults () {

          const jobSearchResults = document.querySelector(".job-search__filters__results");
          const fullJobList = document.querySelector("#jobs-list__list");
          const pagination = document.querySelector("#pagination-nav");
          const mamViewJobList = document.querySelector("#job-search__mapview");
          // Update displayed list.
          fullJobList.innerHTML = '';
          jobCards.forEach((card) => { fullJobList.append(card); });

          jobSearchResults.classList.remove('map-list-open');
          fullJobList.classList.remove('hidden');
          pagination.classList.remove('hidden');
          mamViewJobList.classList.add('hidden');
          resetMapValuesToDefault && resetMapValuesToDefault();
        }
        if(toggleMapViewButton){
          toggleMapViewButton.addEventListener("click", (event) => {
            event.preventDefault();
            const valueButton =  toggleMapViewButton.textContent;
            if(valueButton){
              toggleMapView(valueButton);
            }
            if(valueButton.trim() === __t['jobSearch.hideMapLabel']){
              backToResults();
            }
          });
        }

        backToResultsBtn.addEventListener("click", (event) => {
          event.preventDefault();
          backToResults();
        });

        var dropdownBtn = document.querySelector(".location-radius__button");
        var dropdownContent = document.querySelector("#contentDistance");
        var fields = document.getElementsByClassName('location-radius__field');
        for (var i = 0; i < fields.length; i++) {
          fields[i].addEventListener('click', function () {
            dropdownContent.style.display = "none";
          });
        }
        dropdownBtn.addEventListener("click", function () {
          if (dropdownContent.style.display === "block") {
            dropdownContent.style.display = "none";
          } else {
            dropdownContent.style.display = "block";
          }
        });

        function showTabContent(tabName) {
          var jobDetailsPage = document.getElementsByClassName("jobDetailsPage");
          var quickApplyPage = document.getElementsByClassName("quickApplyPage");

          if (tabName === "job") {
            for (var j = 0; j < jobDetailsPage.length; j++) {
              jobDetailsPage[j].style.display = "block";
            }
            for (var i = 0; i < quickApplyPage.length; i++) {
              quickApplyPage[i].style.display = "none";
            }
          } else if (tabName === "app") {
            for (var i = 0; i < jobDetailsPage.length; i++) {
              jobDetailsPage[i].style.display = "none";
            }
            for (var i = 0; i < quickApplyPage.length; i++) {
              quickApplyPage[i].style.display = "block";
            }
          }
        }

        function onTabClick(evt, pageName = "jobDetails") {
          var tabName = evt.currentTarget.getAttribute("data-tab");
          //updateSidePanelVisibility(tabName);
          showTabContent(tabName);

          for (var k = 0; k < jobDetailsTab.length; k++) {
            jobDetailsTab[k].classList.remove("active");
          }
          if (applicationTab) {
            applicationTab.classList.remove("active");
          }
          // document.getElementById(pageName).style.display = "block";
          evt.currentTarget.classList.add("active");
        }

        function showApplicationTab(evt, pageName = "application") {
          var tabName = evt.currentTarget.getAttribute("data-tab");
          //updateSidePanelVisibility(tabName);
          showTabContent(tabName);

          for (var j = 0; j < jobDetailsTab.length; j++) {
            jobDetailsTab[j].classList.remove("active");
          }
          if (applicationTab) {
            applicationTab.classList.remove("active");
          }
          // document.getElementById(pageName).style.display = "block";
          evt.currentTarget.classList.add("active");
          window.loadRecaptcha && window.loadRecaptcha("#quickResumeApplyDetails");
          addResumeInputListener();

          // Track Click on Apply Now Button
          var jobData = document.querySelector("#job-data");
          logWLAnalyticsEvent("Job Apply Selected", {
            jobPostingId: jobData?.dataset?.jobid,
            jobTitle: jobData?.dataset?.jobtitle,
          });
          setupQuickApplyPhoneInput();
        }

        function closeApplicationTab(evt, pageName = "application") {
          var tabName = evt.currentTarget.getAttribute("data-tab");
          //updateSidePanelVisibility(tabName);
          var jobDetailsPage =
            document.getElementsByClassName("jobDetailsPage");
          for (var i = 0; i < jobDetailsPage.length; i++) {
            jobDetailsPage[i].style.display = "none";
          }
          var quickApplyPage =
            document.getElementsByClassName("quickApplyPage");
          for (var i = 0; i < quickApplyPage.length; i++) {
            quickApplyPage[i].style.display = "block";
          }
          for (var j = 0; j < jobDetailsTab.length; j++) {
            jobDetailsTab[j].classList.remove("active");
          }
          if (applicationTab) {
            applicationTab.classList.add("active");
          }
          document.getElementById(pageName).style.display = "block";
          evt.currentTarget.classList.add("active");
          window.loadRecaptcha && window.loadRecaptcha("#quickResumeApplyDetails");
          addResumeInputListener();

          // Track Click on Apply Now Button
          var jobData = document.querySelector("#job-data");
          logWLAnalyticsEvent("Job Apply Selected", {
            jobPostingId: jobData?.dataset?.jobid,
            jobTitle: jobData?.dataset?.jobtitle,
          });
          setupQuickApplyPhoneInput();
        }

        function addJobTabsListeners() {
          jobDetailsTab = document.querySelectorAll(".jobDetailsTab");
          applyNowBtn = document.querySelectorAll(".applyNowBtn");
          applicationTab = document.querySelector(".applicationTab");
          const shareButton = document.querySelector('.shareButton');
          const shareModal = document.getElementById('shareModal');
          const closeButton = document.querySelector('.share-modal__close');
          const faceBook = document.querySelector(".faceBook");
          const copyLink = document.querySelector(".copyToClipBoard");
          const email = document.querySelector(".email");
          const linkedIn = document.querySelector(".linkedIn");
          const twitter = document.querySelector(".twitter");

          applicationTab && applicationTab.addEventListener("click", showApplicationTab);
          jobDetailsTab.forEach(btn => btn.addEventListener('click', onTabClick));
          applyNowBtn.forEach(btn => btn.addEventListener('click', closeApplicationTab));
          shareButton?.addEventListener('click', openJobShareModl);
          closeButton?.addEventListener('click', closeModal);
          shareModal?.addEventListener('click', (e) => {
            if (e.target === shareModal) {
                closeModal();
            }
          });
          copyLink?.addEventListener("click", onCopyShareLink);
          email?.addEventListener("click", onEmailShareLink);
          faceBook?.addEventListener('click', onFbShareLink);
          linkedIn?.addEventListener("click", onLinkedInShareLink);
          twitter?.addEventListener("click", onTwitterShareLink);
        }

        addJobTabsListeners();

        window.addEventListener('resize', handleResize);
        const parentElement = searchForm.querySelector('.advanced_filters');
        const webViewClone =  searchForm.querySelector('.webView');
        const mobileViewClone = searchForm.querySelector('.mobileView');

        function handleResize() {
          var mobileView = searchForm.querySelector('.mobileView');
          var webView =  searchForm.querySelector('.webView');
          // This function will be called whenever the window is resized
          if(window.innerWidth<=1200){

            if(mobileView==null && webView !=null){
              parentElement.removeChild(webView);
              parentElement.appendChild(mobileViewClone);
            }
            else if(mobileView=!null && webView !=null){
              parentElement.removeChild(webView);
            }
          }
          else{
            if(mobileView!=null && webView ==null){
              parentElement.removeChild(mobileView);
              parentElement.appendChild(webViewClone);
            }
            else if(mobileView!=null && webView !=null){
              parentElement.removeChild(mobileView);
            }
          }
        }
        handleResize();
        var filterskillsParent = null;
        var theme = null;
        const data = document.getElementById("job-search-filters__form_splitscreen").dataset;
        if (data) {
          theme = data['theme'];
          baseUrl = data['baseurl'];
        }
        /**
         * Handle expanding of filters collapse
         */
        const filterAccordions = searchForm.querySelectorAll('.filters__advanced__list__filter');
        filterAccordions.forEach((accordion) => {
          const button = accordion.querySelector('.collapse-toggle');
          const collapse = accordion.querySelector('.filters-collapse');
         // expanding pre-selected filters
          if (button.classList.contains('active')) {
            collapse.style.maxHeight = `${collapse.scrollHeight}px`;
            collapse.style.overflow = 'visible';
          }

          button.addEventListener('click', () => {
            if (button.classList.contains('active')) {
              button.classList.remove('active');
              collapse.style.maxHeight = 0;
              collapse.style.overflow = 'hidden';
            } else {
              button.classList.add('active');
              collapse.style.maxHeight = `${collapse.scrollHeight}px`;
              setTimeout(() => collapse.style.overflow = 'visible', 200);
            }
          });
        })



        searchForm.addEventListener('submit', (evt) => {
          evt.preventDefault();
          displayAlerts();
          var allInputs = searchForm.getElementsByTagName('input');
          const selected = [];

          for (var i = 0; i < allInputs.length; i++) {
            var input = allInputs[i];
            if (input) {
              if (input.name && !input.value) {
                input.name = '';
              }

              if (input.name && (((input.type == 'checkbox' || input.type == 'radio') && input.checked) || input.type == 'range')) {
               if (input.type == 'range' && (input.value == 0 || input.value == '0'))
                  input.name = '';
                else if (!selected.includes(`${input.name}=${input.value}`))
                  selected.push(`${input.name}=${input.value}`);
                else
                  input.name = '';
              }
            }
          }
        });


        var stickyContainerOffset= 260;
        var stickyScrollHeight= 800;
        let stickyScroll = document.querySelector('.job-search__jobs-list');
        let stickyContainer = document.querySelector('.job-list-container');
        if(stickyScroll) stickyScrollHeight =  stickyScroll.clientHeight
        if(stickyContainer) stickyContainerOffset =  stickyContainer.offsetTop

        function handleScroll() {
          const stickyContainer = document.querySelector('.job-list-container');
          const stickyScroll = document.querySelector('.job-search__jobs-list');
          const splitBody = document.querySelector('#split-screen-body');
          const jobDetailsElement = document.getElementById("jobDetails");
          const isLargeScreen = jobDetailsElement && jobDetailsElement.checkVisibility({checkVisibilityCSS: true}) && stickyContainer.checkVisibility({checkVisibilityCSS: true});

          if(isLargeScreen) {
            splitBody && (splitBody.style.minHeight = splitBody.clientHeight + 'px');
          } else {
            splitBody.classList.remove('sticky-content');
            stickyScroll.style.height = '';
            return;
          }
          const scrollTop = document.scrollTop || window.scrollY;
          const splitBottom = splitBody.offsetTop + splitBody.clientHeight;
          const bottomPosition = scrollTop + window.innerHeight;
          if(stickyContainerOffset < scrollTop) {
            splitBody.classList.add('sticky-content');
          } else {
            splitBody.classList.remove('sticky-content');
          }
          if(splitBottom < bottomPosition) {
            stickyScroll.style.height = (stickyScrollHeight - (bottomPosition - splitBottom) ) + 'px';
          } else {
            stickyScroll.style.height = '';
          }
        }

        document.addEventListener('scroll', handleScroll);



        const inputs = searchForm.querySelectorAll('input[type=checkbox]:not(.btn-sort):not(.job-alerts-input):not(.quickapply-input)');
        inputs.forEach(input => input.addEventListener('change', () => {
          const theme = searchForm.dataset['theme']
          if (theme === 'theme2') {
            return;
          }
          onFilterChange();
        }));

        const rangeSliders = searchForm.querySelectorAll('input[type=range]');
        rangeSliders.forEach(rangeSlider => {
          const rangeSliderValue = searchForm.querySelector(`#${rangeSlider.id}-slider-value`.replace(/[.,\/!$%\^&\*;:{}=\`~() ]/g, (match) => `\\${match}`));
          rangeSlider.addEventListener('change', () => {
            rangeSliderValue.innerHTML = rangeSlider.value;
            onFilterChange();
          })
        });


        const singleselect= searchForm.querySelectorAll('input[type=select]');

        loadPageSize(searchForm);
        addPageListeners();
        addLocationListeners();
        addSortListeners();
        addPageSizeListeners();
        addMultiSelectInputListeners();
        addfilterOverlayListener();
        addFavoriteListener();
        addTheme2Listener();
        addJobLinksListener();
        addQuickApplySubmitEvent();
        showHideJobDetails();
        addResumeInputListener();

        // Jov is selected ()
        const id = window.location.pathname.split('-').pop();
        if(largeScreen && !isNaN(id)) {
          showJobDetails();
          addJobDetailBackBtnListener();
        }
        addJobDetailBackBtnListener();

        function addResumeInputListener(){
          const resumeField = searchForm.querySelector('#quickapply-resume');
          const resumeFieldLabel = searchForm.querySelector('#quickapply-resume-label');

          if (resumeField && resumeFieldLabel) {
            resumeField.addEventListener('change', () => {
              if (resumeField.files.length > 0) {
                resumeFieldLabel.innerHTML = `<span>${resumeField.files[0].name}</span>`;
              }
            });
          }
        }

        function addJobLinksListener() {
          const jobItems = document.querySelectorAll('.job-search__jobs-list__job');
          const jobDetails = searchForm.querySelector('#job-data');
          const currentJobId = jobDetails ? jobDetails.dataset['jobid'] : 0;

          jobItems.forEach(item => {
            const link = item.querySelector('.job-search__jobs-list__job-name a');
            const linkJobId = link?.getAttribute('data-jobid');
            if (currentJobId === linkJobId) {
              item.classList.add('job-selected');
            }
            item.addEventListener('click', async (event) => {
              const isFavorite = event.target.closest('.icon-favorite');
              const isAnchor = event.target.closest('a');
              if (isFavorite || isAnchor?.classList.contains('external-link')) return;
              event.preventDefault();
              const jobId = link?.getAttribute('data-jobid');
              const jobSlug = link?.getAttribute('data-slug');
              const jobTitle = link?.textContent?.trim();

              if (!jobId) return;

              jobItems.forEach(j => j.classList.remove('job-selected'));
              item.classList.add('job-selected');

              try {
                toggleLoadingSpinner(true);
                const jobDetailsData = await getJob(jobId);
                if (jobDetailsData) {
                  renderJobDetailsResults(jobDetailsData);
                  // item.classList.add('job-selected');
                  showJobDetails();
                }

                toggleMapView(__t['jobSearch.hideMapLabel']);
                updatePageUrl(jobSlug, true);
                logWLAnalyticsEvent("Job Details Viewed", {
                  jobPostingId: jobId,
                  jobTitle: jobTitle,
                });
              } catch (err) {
                console.error("Error loading job:", err);
              }
              toggleLoadingSpinner(false);
              resetMapValuesToDefault && resetMapValuesToDefault();
            });
          });
        }
        function updatePageUrl(slug, triggerPopSateEvent = false) {
          const pageUrl = searchForm.dataset.currentPageUrl;
          const search = window.location.search;
          const url = new URL(`${pageUrl}/${slug}${search}`);
          const splitUrl = new URL(`${pageUrl}/${search}`);
          url.searchParams.delete('successfullyApplied');
          window.history.pushState(null, null, splitUrl.toString());
          // window.history.pushState(null, null, url.toString());

          updateCanonical(url.toString());

          if (triggerPopSateEvent) {
            dispatchEvent(new PopStateEvent('popstate'));
          }
        }

        function updateCanonical(url) {
          try{
              const parsedUrl = new URL(url);
              const prefix = '/job';
              const pathParts = parsedUrl.pathname.split('/').filter(Boolean);
              const slug = pathParts[pathParts.length - 1];
              const canonicalUrl = `${parsedUrl.origin}${prefix}/${slug}`;
              let canonical = document.querySelector('link[rel="canonical"]');
              // if (!canonical) {
              //   canonical = document.createElement('link');
              //   canonical.rel = 'canonical';
              //   document.head.appendChild(canonical);
              // }
              // canonical.href = canonicalUrl;
          } catch (e) {
           console.error('Invalid URL passed to updateCanonicalFromUrl', e);
          }
        }

        function addJobDetailBackBtnListener(){
          const backBtn = document.querySelector('.job-details-back-btn');
          // Back
          backBtn && backBtn.addEventListener('click', (event) => {
            event.preventDefault();
            hideJobDetails();
            const url = searchForm.dataset.currentPageUrl;
            const search = window.location.search;
            window.history.pushState(null, null, `${url}${search}`);
            dispatchEvent(new PopStateEvent('popstate'));
          });
        }

        function toggleLoadingSpinner(show) {
          const overlay = document.querySelector("#loading-overlay");
          const spinner = document.querySelector('#loading-spinner');
          if(!(overlay && spinner)) return;
          if(show) {
            overlay.classList.remove('hidden');
            spinner.classList.remove('hidden');
          } else {
            overlay.classList.add('hidden');
            spinner.classList.add('hidden');
          }

        }

        /**
         * We want to simulate radio buttons that can be de-selected. Instead of using actual radios, we
         * use checkboxes that de-select all other checkboxes when selected.
         */
        const customRadios = searchForm.querySelectorAll('input[type=checkbox].custom-radio');
        customRadios.forEach((customRadio) => {
          customRadio.addEventListener('click', (e) => {
            if (customRadio.checked) {
              // Select checkboxes with same class list (should contain the same filter name as part of one of the classes)
              const groupSelector = customRadio.className.split(' ').map((className) => `.${className.replace(/[.,\/!$%\^&\*;:{}=\`~() ]/g, (match) => `\\${match}`)}`).join('');
              const groupedCustomRadios = searchForm.querySelectorAll(groupSelector)
              groupedCustomRadios.forEach((groupedCustomRadio) => {
                if (customRadio != groupedCustomRadio) groupedCustomRadio.checked = false
              });
            }
          })
        })

        const clearAllButtons = searchForm.querySelectorAll('.clear-all-button');
        clearAllButtons.forEach(button => button.addEventListener('click', clearAll));

        function clearAll(e) {
          e.preventDefault();
          // Reset all text inputs
          const textInputs = searchForm.querySelectorAll('input[type=text]');
          // const selectField = searchForm.querySelector('select');
          // const filterLabel= selectField.getAttribute('data-label')

          textInputs.forEach((input) => {
            var details= input.dataset;
            var placeHolder = details["label"];
            var type = details["type"];
            if(type=='multi-select'|| type=='single-select'){
              input.placeholder = `${__t['jobSearch.searchLabel']} ${placeHolder}`;
            }
            var salary_filter = searchForm.querySelector('.salary_filter_text')
            if(salary_filter){
              salary_filter.textContent='0'
            }

            input.value = '';


          });
          var jobAlertsLabel = searchForm.querySelector('#job-alerts-label');
          if (jobAlertsLabel && jobAlertsLabel.innerHTML == 'Alerts saved'){
            jobAlertsLabel = __t['jobAlert.getAlertsLabel']
          }

          // Clear google auto-suggest input
          const locationInput = searchForm.querySelector('#Facility\\.location');
          locationInput && (locationInput.value = '');

          // Remove all mutli select inputs
          const mutliSelectInputs = searchForm.querySelectorAll('.multi-select-filter-value');
          mutliSelectInputs.forEach((input) => {
            input.remove();
          });

          // Remove all multi select input display pills
          const multiSelectDisplayPills = searchForm.querySelectorAll('.filters__advanced__list__filter__applied__value');
          multiSelectDisplayPills.forEach((pill) => {
            pill.remove();
          });

          // Select all checked inputs and set their checked to false
          const inputs = searchForm.querySelectorAll('input[type=checkbox]:checked, input[type=radio]:checked');
          inputs.forEach((input) => {
            input.checked = false;
          });

          // Reset Location Radius
          const radiusField = searchForm.querySelector('.location-radius__wrapper');
          if (radiusField) {
            radiusField.classList.remove('hidden');
          }

          // Reset range slider
          const rangeInputs = searchForm.querySelectorAll('input[type=range]');
          rangeInputs.forEach((input) => {
            input.value = 0;
          });

          removeCustomPageSize(searchForm);

          onFilterChange();
        }

        function onDocumentClick(el) {
          var dropDowns = searchForm.getElementsByClassName('dropdown-fields');
          for (var i = 0; i < dropDowns.length; i++) {
            if (el.id != dropDowns[i].parentNode.querySelector('input').id) {
              dropDowns[i].parentNode.removeChild(dropDowns[i]);
            }
          }
        }

        document.addEventListener('click', (e) => onDocumentClick(e.target));

        const multiSearches = searchForm.querySelectorAll('.filters-collapse');

        multiSearches.forEach((multiSearch) => {
          if (!multiSearch.querySelector('.multi-search-field')) return;

          const inputField = multiSearch.querySelector('input[type=text]');
          const selectField = multiSearch.querySelector('select');
          var filterValues = [];
          selectField.querySelectorAll('option').forEach(option =>
            filterValues.push({value: option.value, display: option.text})
          );

          const filterSlugAlias = selectField.getAttribute('data-filterslugalias');
          const filterName = selectField.getAttribute('data-filtername');
          const fieldType = selectField.getAttribute('data-fieldtype');
          const displayType = selectField.getAttribute('data-displaytype');
          const filterLabel= selectField.getAttribute('data-label')

          addDropDownInitialLoad(multiSearch.parentNode, inputField, filterValues, filterSlugAlias, filterName, fieldType, displayType,filterLabel);

          addDropDown(multiSearch.parentNode, inputField, filterValues, filterSlugAlias, filterName, fieldType, displayType,filterLabel);
        });

        function closeAllLists() {
          var dropDowns = searchForm.getElementsByClassName('dropdown-fields');
          for (var i = 0; i < dropDowns.length; i++) {
            dropDowns[i].parentNode.removeChild(dropDowns[i]);
          }
        }

         function addDropDown(parent, input, arr, filterSlugAlias, filterName, fieldType, displayType,filterLabel) {
          let currentFocus;

          function focusOrInputHandler() {
            const value = this.value
            closeAllLists();
            currentFocus = -1;
            const dropDown = document.createElement('DIV');
            dropDown.setAttribute('id', `${this.id}-dropdown-list`);
            dropDown.setAttribute('class', 'dropdown-fields');

            this.parentNode.appendChild(dropDown);
            for (let i = 0; i < arr.length; i++) {
              if (value) {
                if (arr[i].display.toUpperCase().includes(value.toUpperCase())) {
                  const dropDownField = addDropDownField(arr[i].display, arr[i].value, filterSlugAlias, filterName, fieldType, displayType,input,filterLabel);
                  dropDown.appendChild(dropDownField);
                }
              } else {
                const dropDownField = addDropDownField(arr[i].display, arr[i].value, filterSlugAlias, filterName, fieldType, displayType,input,filterLabel);
                dropDown.appendChild(dropDownField);
              }
            }

          }

          input.addEventListener('input', focusOrInputHandler);
          input.addEventListener('focus', focusOrInputHandler);

          function addDropDownField(display, value, filterSlugAlias, filterName, fieldType, displayType,input,filterLabel) {


            var urlParams= getAllInputValues();
            var checked=false
            var selected = false
            var params=urlParams.split('&')
            for(var i=0;i<params.length;i++){

              var values=params[i].split("=")
              if(values[0].toLowerCase().trim()==filterSlugAlias.toLowerCase()){
                  if((values[1].trim()==display.replace(/ /g,"%20").trim())|| (values[1].trim()==display.replace(/ /g,"+").trim())){
                    if( displayType=='multi-select'){
                    checked =true
                    }
                    else if( displayType=='select'){
                      selected = true
                    }
                  }
              }
            }

            const field = document.createElement('DIV');

            if(checked){
              var index=-1
              for(var i=0;i<checkedFilters.length;i++){
                if(checkedFilters[i]["filterLabel"]==filterLabel){
                  index=i
                }
              }
            if(index!=-1){
              if( !checkedFilters[index].values.includes(display)){

              checkedFilters[index].values.push(display)
              }


            }
            else{
              checkedFilters.push({"filterLabel":filterLabel,"values":[display]})

            }
            field.classList.add("splitscreen_selectedhighlight")
            field.innerHTML = `<input checked="true" type="checkbox" value="true" id="checktest${value}"/> ${display}`;
            }
             else if(!checked &&  displayType=='multi-select'){
              field.innerHTML = `<input type="checkbox" id="checktest${value}"/> ${display}`;

            }

            else if(selected && displayType=='select'){
              // field.style.backgroundColor='#d3d3d3'
              field.classList.add("splitscreen_selectedhighlight")
              field.innerHTML = `<input  type="hidden" value="true" id="checktest${value}"/> ${display}`;

              var index=-1

              for(var i=0;i<checkedFilters.length;i++){
                index=1
                if(checkedFilters[i]["filterLabel"]==filterLabel){


                    checkedFilters[i].values=value

                }
                else{
                  checkedFilters.push({"filterLabel":filterLabel,"values":[display]})
                }
              }
            }
            else if(!selected && displayType=='select'){
              field.innerHTML = `<input type="hidden" id="checktest${value}"/> ${display}`;

            }
            field.innerHTML += `<input type="hidden" value="${display}">`;
            field.innerHTML += `<input type="hidden" value="${value}">`;

            field.addEventListener('click', function (e) {
              var alreadyChecked=null
              input.value=""
              const display = this.getElementsByTagName('input')[1].value;
              const value = this.getElementsByTagName('input')[2].value;
              var element=this.getElementsByTagName('input')[0];
              if(element.value=='true'){
                alreadyChecked=element.value
              }
              const type = (displayType == 'multi-select') ? 'checkbox' : 'radio';
              var selectedFields = null
               if (filterName == 'SkillType.skillTypeId' && filterskillsParent != null) {
                 selectedFields = filterskillsParent.querySelector('.filters__advanced__list__filter__applied');
                 filterskillsParent = null
               } else {
                selectedFields = parent.querySelector('.filters__advanced__list__filter__applied');
               }
               var isMobileView=  window.innerWidth;

               if(isMobileView>1200 && displayType=='multi-select'){
              multiSelectPlaceHolder( input, alreadyChecked,display,filterLabel,checkedFilters)
               }
               else if(isMobileView>1200 && displayType=='select'){
                singleSelectPlaceHolder(input, selected,display,filterLabel)
               }
              if (selectedFields) {
                if (type == 'radio') selectedFields.innerHTML = "";

                if(isMobileView>1200  && alreadyChecked==null){
                selectedFields.innerHTML +=
                  `<div style="display:none" class="filters__advanced__list__filter__applied__value multi-select__${filterName}__${value}" data-filterdata="${filterName}__${value}">
                    <input type="${type}" class="btn-check" id="${filterName}__${value}" name="${filterSlugAlias}" value="${display}" data-filtername="${filterName}" data-fieldtype="${fieldType}" data-displaytype="${displayType}" checked>
                    <label class="btn btn-outline-primary custom" for="${filterName}__${value}">${display}<svg width="12" height="12" viewBox="0 0 10 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6.05752 5.49999L9.28251 2.28249C9.42374 2.14126 9.50308 1.94971 9.50308 1.74999C9.50308 1.55026 9.42374 1.35871 9.28251 1.21749C9.14129 1.07626 8.94974 0.996918 8.75002 0.996918C8.55029 0.996918 8.35874 1.07626 8.21752 1.21749L5.00002 4.44249L1.78252 1.21749C1.64129 1.07626 1.44974 0.996918 1.25002 0.996918C1.05029 0.996918 0.858743 1.07626 0.717515 1.21749C0.576287 1.35871 0.496946 1.55026 0.496946 1.74999C0.496946 1.94971 0.576287 2.14126 0.717515 2.28249L3.94252 5.49999L0.717515 8.71749C0.647219 8.78721 0.591423 8.87016 0.553347 8.96155C0.51527 9.05295 0.495667 9.15098 0.495667 9.24999C0.495667 9.349 0.51527 9.44703 0.553347 9.53842C0.591423 9.62981 0.647219 9.71276 0.717515 9.78249C0.787237 9.85278 0.870188 9.90858 0.961583 9.94666C1.05298 9.98473 1.15101 10.0043 1.25002 10.0043C1.34902 10.0043 1.44705 9.98473 1.53845 9.94666C1.62984 9.90858 1.71279 9.85278 1.78252 9.78249L5.00002 6.55749L8.21752 9.78249C8.28724 9.85278 8.37019 9.90858 8.46158 9.94666C8.55298 9.98473 8.65101 10.0043 8.75002 10.0043C8.84902 10.0043 8.94705 9.98473 9.03845 9.94666C9.12984 9.90858 9.21279 9.85278 9.28251 9.78249C9.35281 9.71276 9.40861 9.62981 9.44668 9.53842C9.48476 9.44703 9.50436 9.349 9.50436 9.24999C9.50436 9.15098 9.48476 9.05295 9.44668 8.96155C9.40861 8.87016 9.35281 8.78721 9.28251 8.71749L6.05752 5.49999Z" fill="#333C59"></path>
                  </svg></label>
                </div>`;
                addMultiSelectInputListeners(selectedFields);
                }
               else if(isMobileView<=1200  && alreadyChecked==null){
                  selectedFields.innerHTML +=
                  `<div class="filters__advanced__list__filter__applied__value multi-select__${filterName}__${value}" data-filterdata="${filterName}__${value}">
                    <input type="${type}" class="btn-check" id="${filterName}__${value}" name="${filterSlugAlias}" value="${display}" data-filtername="${filterName}" data-fieldtype="${fieldType}" data-displaytype="${displayType}" checked>
                    <label class="btn btn-outline-primary custom" for="${filterName}__${value}">${display}<svg width="12" height="12" viewBox="0 0 10 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6.05752 5.49999L9.28251 2.28249C9.42374 2.14126 9.50308 1.94971 9.50308 1.74999C9.50308 1.55026 9.42374 1.35871 9.28251 1.21749C9.14129 1.07626 8.94974 0.996918 8.75002 0.996918C8.55029 0.996918 8.35874 1.07626 8.21752 1.21749L5.00002 4.44249L1.78252 1.21749C1.64129 1.07626 1.44974 0.996918 1.25002 0.996918C1.05029 0.996918 0.858743 1.07626 0.717515 1.21749C0.576287 1.35871 0.496946 1.55026 0.496946 1.74999C0.496946 1.94971 0.576287 2.14126 0.717515 2.28249L3.94252 5.49999L0.717515 8.71749C0.647219 8.78721 0.591423 8.87016 0.553347 8.96155C0.51527 9.05295 0.495667 9.15098 0.495667 9.24999C0.495667 9.349 0.51527 9.44703 0.553347 9.53842C0.591423 9.62981 0.647219 9.71276 0.717515 9.78249C0.787237 9.85278 0.870188 9.90858 0.961583 9.94666C1.05298 9.98473 1.15101 10.0043 1.25002 10.0043C1.34902 10.0043 1.44705 9.98473 1.53845 9.94666C1.62984 9.90858 1.71279 9.85278 1.78252 9.78249L5.00002 6.55749L8.21752 9.78249C8.28724 9.85278 8.37019 9.90858 8.46158 9.94666C8.55298 9.98473 8.65101 10.0043 8.75002 10.0043C8.84902 10.0043 8.94705 9.98473 9.03845 9.94666C9.12984 9.90858 9.21279 9.85278 9.28251 9.78249C9.35281 9.71276 9.40861 9.62981 9.44668 9.53842C9.48476 9.44703 9.50436 9.349 9.50436 9.24999C9.50436 9.15098 9.48476 9.05295 9.44668 8.96155C9.40861 8.87016 9.35281 8.78721 9.28251 8.71749L6.05752 5.49999Z" fill="#333C59"></path>
                  </svg></label>
                </div>`;
                addMultiSelectInputListeners(selectedFields);
                }
                else{
                    var test=filterName+"__"+value
                  var ele= document.getElementById(test);
                  if(ele!=null && ele.parentNode!=null){
                  ele.parentNode.removeChild(ele);
                  }
                }
                closeAllLists();
                onFilterChange();
              } else {

                // Added search field for theme2 filters
                selectedFields = document.getElementById(`${filterName}__${value}`);
                if (selectedFields) selectedFields.checked = true;
              }
            });
            return field;
          }

          input.addEventListener('keydown', function (e) {
            var dropdown = searchForm.querySelector(`#${this.id}-dropdown-list`.replace(/[.,\/!$%\^&\*;:{}=\`~() ]/g, (match) => `\\${match}`));
            if (dropdown) dropdown = dropdown.getElementsByTagName('div');
            if (e.keyCode == 40) {
              currentFocus++;
              addActive(dropdown);
            } else if (e.keyCode == 38) {
              currentFocus--;
              addActive(dropdown);
            } else if (e.keyCode == 13) {
              e.preventDefault();
              if (currentFocus > -1) {
                if (dropdown) dropdown[currentFocus].click();
              }
            }
          });

          function addActive(d) {
            if (!d) return false;
            for (var i = 0; i < d.length; i++) d[i].classList.remove('dropdown-active');
            currentFocus = currentFocus >= d.length ? 0 : (currentFocus < 0 ? d.length - 1 : currentFocus);
            d[currentFocus].classList.add('dropdown-active');
          }


        }
        function singleSelectPlaceHolder(input, alreadyChecked,display,filterLabel){
          if(alreadyChecked==null || alreadyChecked==false){
              if(display.length>13){
                input.placeholder= display.slice(0,13) + "..";
              }
              else{
                input.placeholder= display
              }
          }
          else if(alreadyChecked){
            input.placeholder = `${__t['jobSearch.searchLabel']} ${filterLabel}`;
          }
        }
        function multiSelectPlaceHolder(input, alreadyChecked,display,filterLabel, checkedFilters){
          var values=null
          var index=-1
          if(checkedFilters!=null){
          for(var i=0; i<checkedFilters.length;i++){
            if(checkedFilters[i]["filterLabel"]==filterLabel){
              values=checkedFilters[i].values
              index=i
            }
          }
        }
          if(!input.placeholder.includes(__t['jobSearch.searchLabel'])&& alreadyChecked==null && !input.placeholder.includes("values selected")){
            var check=input.placeholder.split("+")
            if(check.length>1){
              var slicedString;
              if(display.length>10){
                slicedString= check[0].slice(0,9) + "..";
              }
              else{
                slicedString= check[0]
              }

             var num= parseInt(check[1][0])
             num= num+1
             var val = num.toString()
             input.placeholder=slicedString+"+"+val+" "+__t['jobSearch.moreLabel'];
            }
            else{
              input.placeholder= input.placeholder+"+1 "+__t['jobSearch.moreLabel'];
            }

          }
          else if(!input.placeholder.includes(__t['jobSearch.searchLabel'])&& alreadyChecked==null && input.placeholder.includes("values selected")){
          var values= input.placeholder.split(" ")
          var num= values[0]
          if(display.length>10){
            var slicedString= display.slice(0,9) + "..";
            input.placeholder=slicedString+"+"+num+" "+__t['jobSearch.moreLabel'];
            }
            else{
          input.placeholder=display+"+"+num+" "+__t['jobSearch.moreLabel'];
          }
          }
          else if(alreadyChecked=='true'){

              const indexToRemove = checkedFilters[index].values.indexOf(display);
              checkedFilters[index].values.splice(indexToRemove, 1);
              var values= checkedFilters[index].values
            var check=input.placeholder.split("+")
            var slicedString;
            if(values[0] && display.length>10){
              slicedString= values[0].slice(0,9) + "..";
            }
            else{
              slicedString= values[0]
            }
            if(check.length>1 && check[0]!=slicedString){
              var num= parseInt(check[1][0])
              num= num-1
              var val = num.toString()
              if(num!=0){
              input.placeholder=slicedString+"+"+val+" "+__t['jobSearch.moreLabel'];
              }
              else{
                input.placeholder=slicedString
              }
             }
             else if(check.length>1 && slicedString==display){
              var num= parseInt(check[1][0])-1
              var val = num.toString()
              if(values){
                if(num>=1){
                  input.placeholder=slicedString+"+"+num+" "+__t['jobSearch.moreLabel'];

                }
                else{
                  if(num==0){
                    input.placeholder=slicedString

                  }
                }

              }

             }
             else{
              input.placeholder = `${__t['jobSearch.searchLabel']} ${filterLabel}`;
             }

          }
          else{
            if(display.length>10){
            var slicedString= display.slice(0,9) + "..";
            input.placeholder=slicedString
            return
            }
            input.placeholder=display



          }
        }

        function addPageListeners() {
          const pageLinks = searchForm.querySelectorAll('.page-link');
          pageLinks.forEach((pageLink) => {
            const page = parseInt(pageLink.dataset['page'])

            pageLink.addEventListener('click', function () {
              if (!pageLink.classList.contains('selected')) {
                onFilterChange(page);
              }
            });
          });
        }

        function resetPageUrl() {
          const url = searchForm.dataset.currentPageUrl;
          const search = window.location.search;

          window.history.replaceState(null, null, `${url}${search}`);
        }

        function addLocationListeners() {
          // Prevent form submission to let google autocomplete fetch location essential fields
          const locationInput = searchForm.querySelector('#Facility\\.location');
          if (locationInput) {
            locationInput.addEventListener('keypress', (e) => e.key === 'Enter' && e.preventDefault());
          }

          const radiusButton = searchForm.querySelector('.location-radius__button');
          const radiusMenu = searchForm.querySelector('.location-radius__fields');
          if (radiusButton && radiusMenu) {
            radiusButton.addEventListener('click', () => radiusMenu.classList.toggle('expand'));
            const radiusInputs = radiusMenu.querySelectorAll('input[type=radio]');
            radiusInputs.forEach(input => {
              input.addEventListener('click', () => {
                radiusButton.querySelector('span').innerHTML = input.value
                radiusMenu.classList.remove('expand');
              });
            });

            document.addEventListener('click', function (e) {
              if (!e.target.closest('.location-radius__wrapper')) {
                radiusMenu.classList.remove('expand');
              }
            });
          }
        }

        function addSortListeners() {
          const sortDropdowns = searchForm.querySelectorAll('.job-search__filters__sort');

          sortDropdowns.forEach(sortDropdown => {
            const sortButton = sortDropdown.querySelector('.job-search__filters__sort__button');
            var sortMenu = sortDropdown.querySelector('.job-search__filters__sort__menu');

            if (sortMenu) {
              sortButton.addEventListener('click', () => sortMenu.classList.toggle('expand'));
              const sortMenuInputs = sortMenu.querySelectorAll('input[type=checkbox]');
              sortMenuInputs.forEach(sortMenuInput => {
                sortMenuInput.addEventListener('change', () => clearParallelSortInputs(sortMenu, 'radio'));
              });
            } else {
              sortMenu = sortDropdown.querySelector('.job-search__filters__sort__overlay');
              sortButton.addEventListener('click', () => sortMenu.classList.toggle('expand'));
              sortDropdown.querySelector('#sort-overlay-close').addEventListener('click', () => sortMenu.classList.remove('expand'));
              sortDropdown.querySelector('#sort-overlay-submit').addEventListener('click', () => clearParallelSortInputs(sortMenu, 'checkbox'));
            }

            document.addEventListener('click', function (e) {
              if (!e.target.closest('.job-search__filters__sort')) {
                sortMenu.classList.remove('expand');
              }
            });

            function clearParallelSortInputs(sortMenu, parallelType) {
              sortMenu.classList.remove('expand');
              const parallelInputs = searchForm.querySelectorAll(`input[type=${parallelType}].btn-sort`);
              logWLAnalyticsEvent('Job Sort Applied', {
                filterParams: getJobFilters(searchForm),
                sortType: getSortValue(searchForm),
              });
              parallelInputs.forEach(parallelInput => parallelInput.checked = false);
              onFilterChange(1, false);
            }
          });
        }

        function addPageSizeListeners() {
          const pageSizeSelectors = searchForm.querySelectorAll('.page-size-selector');

          if (pageSizeSelectors) {
            pageSizeSelectors.forEach(pageSizeSelector => pageSizeSelector.addEventListener('change', e => {
              setPageSizeEvent(e, searchForm);
              onFilterChange();
            }));
          }
        }

        function addMultiSelectInputListeners(parent = document) {
          const multiSelectInputs = parent.querySelectorAll('.filters__advanced__list__filter__applied__value');
          multiSelectInputs.forEach(input => {
            input.addEventListener('click', function () {
              listener(this)
            });
          });

          function listener(el) {
            try {
              el.remove();
              onFilterChange();
            } catch (exc) {
              console.log(exc);
            }
          }
        }

        function addFavoriteListener() {
          const saveIcons = searchForm.querySelectorAll('.btn-favorite, .icon-favorite');
          saveJob(saveIcons);
          addSavedJobEventCallback(saveIcons);
        }


        function addSavedJobEventCallback(saveIcons) {
          saveIcons.forEach(saveIcon => {
            saveIcon.addEventListener(SAVED_JOB_CHANGE_EVENT, (event) => {
              const savedJobsIcons = document.querySelectorAll(
                `.btn-favorite[data-jobid="${event.detail.jobId}"], .icon-favorite[data-jobid="${event.detail.jobId}`
              );

              savedJobsIcons.forEach(savedJobsElement => {
                if (event.detail.removeSavedJob) {
                  savedJobsElement.classList.replace('selected', 'un-selected');
                } else {
                  savedJobsElement.classList.replace('un-selected', 'selected');
                }
              });
            });
          });
        }

        function addTheme2Listener() {
          /* theme 2 --start*/
          const radioButtons = searchForm.querySelectorAll('input[type="radio"].theme2-checkbox')
          if (radioButtons.length) {
            radioButtons.forEach((radioElement) => {
              radioElement.addEventListener('change', () => {
                // onFilterChange()
              })
            })
          }
          const radioLabels = searchForm.querySelectorAll('.theme2-filter-radio-label');
          radioLabels.forEach((radioLabel) => {
            radioLabel.addEventListener('click', (element) => {
              if (element.currentTarget.previousElementSibling.checked) {
                const currTarget = element.currentTarget.previousElementSibling
                setTimeout(() => {
                  currTarget.checked = false;
                  onFilterChange()
                })
              }
            })
          })

          const sortFilter = searchForm.querySelector('#sort-by-filter');
          if (sortFilter) {
            sortFilter.addEventListener('change', () => {
              onFilterChange()
            })
          }

          const sortFilterLg = searchForm.querySelector('#sort-by-filter-lg');
          if (sortFilterLg) {
            sortFilterLg.addEventListener('change', () => {
              onFilterChange()
            })
          }


          const moreOptions = searchForm.querySelectorAll('.more-options')
          if (moreOptions) {
            moreOptions.forEach((el) => {
              el.addEventListener('click', (e) => {

                if (e.target.textContent === __t['jobSearch.seeMoreFilterLabel']) {
                  e.target.classList.add('more-options-expanded');
                  e.target.textContent = __t['jobSearch.seeLessFilterLabel']
                  const filter = e.target.closest('.filter')

                  if (filter) {
                    const filterOptions = filter.querySelectorAll('.filter-option')
                    filterOptions.forEach((option) => {
                      option.classList.add('show')
                      option.classList.remove('hide')
                    })
                    filter.style.maxHeight = filter.scrollHeight + "px"
                  }
                } else if (e.target.textContent === __t['jobSearch.seeLessFilterLabel']) {
                  e.target.classList.remove('more-options-expanded');
                  e.target.textContent = __t['jobSearch.seeMoreFilterLabel']
                  const filter = e.target.closest('.filter')
                  if (filter) {
                    const filterOptions = filter.querySelectorAll('.filter-option')
                    filterOptions.forEach((option, index) => {
                      if (index > 2) {
                        option.classList.remove('show')
                        option.classList.add('hide')
                      }
                    })
                  }
                }
              })
            })
          }


          var acc = searchForm.getElementsByClassName("accordion");
          if (acc) {
            var i;

            for (i = 0; i < acc.length; i++) {
              var panel = acc[i].nextElementSibling;
              panel.setAttribute('data-height', panel.scrollHeight + "px");
              if (!acc[i].classList.contains('active')) {
                panel.style.maxHeight = null;
                panel.style.display = 'none';
              } else {
                panel.style.maxHeight = panel.scrollHeight + "px";
              }
              acc[i].addEventListener("click", function () {
                this.classList.toggle("active");
                var panel = this.nextElementSibling;
                if (this.classList.contains('active')) {
                  panel.style.maxHeight = panel.getAttribute('data-height');
                  panel.style.display = 'block', 200;
                } else {
                  panel.style.maxHeight = null;
                  setTimeout(() => panel.style.display = 'none', 200);
                }
              });
            }
          }

          var filterSection = searchForm.getElementsByClassName('filter-theme2')
          var jobListSection = searchForm.getElementsByClassName('joblist-theme2')

          const applyFIlter = searchForm.querySelector('.apply-filters')
          if (applyFIlter) {
            applyFIlter.addEventListener('click', () => {
              if (filterSection[0].classList.contains('col-12')) {
                filterSection[0].classList.remove('col-12')
                filterSection[0].classList.remove('p-3');
                filterSection[0].classList.add('p-0');
                filterSection[0].style.width = '0px';
                filterSection[0].style.overflow = 'hidden';
                filterSection[0].style.height = '0px';
              }
              onFilterChange()
            })
          }

          const filterToggle = searchForm.querySelector('#filter-toggle-button');
          const emailAlertSection = searchForm.querySelector('.email-alert');
          const emailAlertEnabled = searchForm.dataset['emailAlert'];
          if (filterSection && jobListSection && filterToggle) {
            jobListSection[0].classList.add(screen.width < 990 || emailAlertEnabled === 'false' ? 'col-12' : 'col-8')
            filterToggle.addEventListener('click', () => {
              if (filterSection[0].style.width === "0px") {
                filterSection[0].classList.add('col-4')
                filterSection[0].style.width = "";
                filterSection[0].style.overflow = "";
                filterSection[0].style.height = null;
                filterSection[0].classList.add('p-3')
                filterSection[0].classList.remove('p-0');
                if (emailAlertSection) {
                  emailAlertSection.classList.remove('d-lg-block');
                }
                if (emailAlertEnabled === 'false' && screen.width > 990) {
                  jobListSection[0].classList.add('col-8')
                  jobListSection[0].classList.remove('col-12')
                }

              } else {
                filterSection[0].style.width = "0px";
                filterSection[0].classList.remove('col-4')
                filterSection[0].classList.remove('p-3');
                filterSection[0].classList.add('p-0');
                filterSection[0].style.overflow = "hidden";
                filterSection[0].style.height = '0px';
                if (emailAlertSection) {
                  emailAlertSection.classList.add('d-lg-block');
                }
                if (emailAlertEnabled === 'false' && screen.width > 990) {
                  jobListSection[0].classList.remove('col-8')
                  jobListSection[0].classList.add('col-12')
                }
              }
            })
          }
          const filterToggleLg = searchForm.querySelector('#filter-toggle-button-lg')
          if (filterToggleLg && jobListSection && filterToggle) {
            filterToggleLg.addEventListener('click', () => {
              if (filterSection[0].classList.contains('col-12')) {
                filterSection[0].classList.remove('col-12')
                filterSection[0].classList.remove('p-3');
                filterSection[0].classList.add('p-0');
                filterSection[0].style.width = '0px';
                filterSection[0].style.overflow = 'hidden';
                filterSection[0].style.height = '0px';
              } else {
                filterSection[0].classList.add('col-12')
                filterSection[0].classList.add('p-3');
                filterSection[0].classList.remove('p-0');
                filterSection[0].style.width = "";
                filterSection[0].style.overflow = "";
                filterSection[0].style.height = '';
              }
            })
          }
          /* ends */
        }

        function addfilterOverlayListener() {
          const filtersOverlayCloseButton = searchForm.querySelector('#close-overlay-button');
          const filtersOverlayButton = searchForm.querySelector('#filters-overlay-button');
          const filter = searchForm.querySelector('.filters__advanced');
          if (filtersOverlayButton) {

            filtersOverlayButton.addEventListener('click', () => {
              filter.classList.add('open');
              document.querySelector('body').style.overflowY = 'hidden';
            });
          }

          if (filtersOverlayCloseButton) {
            filtersOverlayCloseButton.addEventListener('click', () => {
              filter.classList.remove('open');
              document.querySelector('body').style.overflowY = 'visible';
            });
          }
        }

        function onChangeEnableJobAlert() {

          const jobAlertsLabel = searchForm.querySelector('#job-alerts-label');
          if (jobAlertsLabel && jobAlertsLabel.innerHTML == 'Alerts saved') {
            jobAlertsLabel.innerHTML = __t['jobAlert.getAlertsLabel'];
            jobAlertsToggle.classList.remove('hidden');
            const jobAlertsForm = searchForm.querySelector('.job-alerts__card.form');
            const jobAlertsSuccess = searchForm.querySelector('#job-alert-success');
            jobAlertsSuccess.classList.add('hidden');
            jobAlertsForm.classList.remove('hidden');
            searchForm.querySelector('#show-login-error-message').style.display = "none"
            searchForm.querySelector('#show-error-message').innerHTML = '';
          }
        }

        async function onFilterChange(page = 1, trackEvent = true) {
          searchForm.querySelector('.job-search__jobs-list').scrollTo(0,0);
          toggleProgressIndicators(true);
          displayAlerts();

          onChangeEnableJobAlert();

          const filters = getAllInputValues();
          const widgetConfig = getWidgetConfig();
          const jobData = await getJobs(page, widgetConfig, filters);
            const skillFilterValues = await getSkills(page, widgetConfig, filters);
            skillsUpdated=false
            renderSkillsList(skillFilterValues);
            updateSkillsPlaceHolder();


          renderJobsResults(jobData);
          toggleProgressIndicators(false);

          // We need to re-add event listeners since the sort and pagination elements are re-rendered
          addPageListeners();
          addFavoriteListener();

          addPageSizeListeners();
          setCurrentPageSize(searchForm);

          resetPageUrl();
          trackEvent && logWLAnalyticsEvent('Job Search Completed', {
            filterParams: getJobFilters(searchForm),
            sortType: getSortValue(searchForm),
          });
        }

        async function getSkills(page, config, filters) {
          var url = 'filters'
          try {
            const searchResults = await fetch(`${localePrefix}/api/v1/job-search-split-screen-widget/${url}?${page ? `page=${page}&` : ''}${config}&${filters}`);
            return searchResults.text();
          } catch (error) {
            console.log(error)
          }
          return;
        }

        function skillListHtml(parent) {
          var child1 = parent ? parent.querySelector('.filters__advanced__list') : null;
          var child2 = child1 ? child1.querySelectorAll('.filters__advanced__list__filter') : null;
          var skillsList = null
          for (var i = 0; i < child2.length; i++) {
            if (skillsList == null) {
              var child3 = child2[i].querySelectorAll('.filters-collapse')
              skillsList = child3[0] ? child3[0].querySelector('#skillsList') : null;
              if (skillsList != null) {
                var parent = []
                parent.push([skillsList, child2[i]])
                return parent
              }

            }


          }
          return skillsList
        }

        function renderSkillsList(skills) {
          const htmlDoc = document.createElement('html')
          var parent = searchForm.querySelector('.filters__advanced');
          var skillList = null
          skillList = skillListHtml(parent)
          if (skillList && skillList.length > 0) {
            htmlDoc.innerHTML = skills
            var parent2 = htmlDoc.querySelector('.filters__advanced')
            var updatedSkillList = null
            var updatedSkillList = skillListHtml(parent2)
            var fields = updatedSkillList[0][0].querySelector('select');
            if (updatedSkillList.length > 0 && fields != null) {
              skillList[0][0].innerHTML = updatedSkillList[0][0].innerHTML;
              filterskillsParent = skillList[0][1]
              const selectField = skillList[0][0].querySelector('select');
              var filterValues = [];
              selectField.querySelectorAll('option').forEach(option =>
                filterValues.push({value: option.value, display: option.text})
              );
              const inputField = skillList[0][0].querySelector('input[type=text]')
              const filterSlugAlias = selectField.getAttribute('data-filterslugalias');
              const filterName = selectField.getAttribute('data-filtername');
              const fieldType = selectField.getAttribute('data-fieldtype');
              const displayType = selectField.getAttribute('data-displaytype');
              addDropDown(skillList.parentNode, inputField, filterValues, filterSlugAlias, filterName, fieldType, displayType);
            }
          }
        }

        function displayAlerts() {
          const alertsModal = searchForm.querySelector('#job-alerts-hide')
          if (alertsModal) {
            const jobAlertsLabel = searchForm.querySelector('#job-alerts-label');
            if (jobAlertsLabel && jobAlertsLabel.innerHTML.length==0) {
              jobAlertsLabel.innerHTML = __t['jobAlert.getAlertsLabel'];
            }
            alertsModal.style.setProperty('display', 'flex', 'important');
          }
        }

        function toggleProgressIndicators(loading) {

          const button = searchForm.querySelector('.job-search__filters__basic-filters > .button-wrapper > button');
          const mapViewJobList = searchForm.querySelector("#job-search__mapview");
          const pagination = searchForm.querySelector("#pagination-nav");
          const placeholderList1 = searchForm.querySelector('#loading-placeholder');
          const placeholderList = searchForm.querySelector('#loading-placeholder-theme2');
          const jobsList1 = searchForm.querySelector('#jobs-list__list');
          const jobsList = searchForm.querySelector('#jobs-list-theme2');

          if (button) {
            const searchIcon = button.querySelector('svg');
            const btnSpinner = button.querySelector('.spinner-border');
            if (loading) {
              searchIcon && searchIcon.classList.add('hidden');
              btnSpinner && btnSpinner.classList.remove('hidden');
            } else {
              searchIcon && searchIcon.classList.remove('hidden');
              btnSpinner && btnSpinner.classList.add('hidden')
            }
          }

          if (loading) {
            pagination && pagination.classList.add('hidden');
            placeholderList1 && placeholderList1.classList.remove('hidden');
            jobsList1 && jobsList1.classList.add('hidden')
            placeholderList && placeholderList.classList.remove('hidden');
            jobsList && jobsList.classList.add('hidden');
            toggleLoadingSpinner(true);
          } else {
            pagination && pagination.classList.remove('hidden');
            placeholderList1 && placeholderList1.classList.add('hidden');
            jobsList1 && jobsList1.classList.remove('hidden')
            placeholderList && placeholderList.classList.add('hidden');
            jobsList && jobsList.classList.remove('hidden');
            toggleLoadingSpinner(false);
          }

          if(mapViewJobList) {
            mapViewJobList.classList.add('hidden');
            mapViewJobList.innerHTML = "";
          }

        }

        function getAllInputValues() {
          let selectors = 'input[type=text], input[type=checkbox]:checked, input[type=radio]:checked, input[type=range], '
          if (screen.width > 991) {
            selectors += '#sort-by-filter'
          } else {
            selectors += '#sort-by-filter-lg'
          }
          const checkedInputs = searchForm.querySelectorAll(selectors);
          const filters = [];
          const excludedNames = ['jobAlertsName', 'jobAlertsEmail', 'job-alert-frequency'];

          checkedInputs.forEach((input) => {
            if (excludedNames.includes(input.name)) return;
            if (input.type === 'range' && (input.value === "0" || input.value === 0)) return;
            if (input.value && !filters.includes(`${input.name}=${input.value}`)) filters.push(`${input.name}=${encodeURIComponent(input.value)}`);
          })
          return filters.join('&');
        }
        function getWidgetConfig() {
          const widgetConfig = {
            limit: searchForm.dataset['limit'],
            allowUserDefinePageSize: searchForm.dataset['allowUserDefinePageSize'],
            defaultPageSize: searchForm.dataset['defaultLimit'],
            referralPill: searchForm.dataset['referralpill'],
            referralText: searchForm.dataset['referraltext'],
            jobTitle: searchForm.dataset['jobtitle'],
            savedJob: searchForm.dataset['savedjob'],
            jobCardAttributes: searchForm.dataset['jobcardattributes'],
            displayLogo: searchForm.dataset['displaylogo'],
          };
          const config = [];
          for (const [key, value] of Object.entries(widgetConfig)) {
            config.push(`${key}=${value}`);
          }
          return config.join('&');
        }

        async function getJobs(page, config, filters) {
          try {
            /**
             * Alternatively, for leveraging a built-in Apostrophe API that comes with each page to load a rendered template HTML string
             * https://v3.docs.apostrophecms.org/reference/api/pages.html#get-url-aposrefresh-1
             *
             * const searchResultsPage = await fetch(`?aposRefresh=1&${page ? `page=${page}&` : ''}${filters}`);
             *
             * Note:
             *  This allows a fetch to a relative URL, so the job search widget can be placed on any page and the same page will be requested.
             * The only problem is this requests the entire page so it is not as efficient as using a renderRoutes API.
             */

              // Calling an API route created with the job-search-split-screen-widget module using renderRoutes
              // https://v3.docs.apostrophecms.org/reference/module-api/module-overview.html#renderroutes-self
            let themeType = 'job-search'
            if (config.includes('theme=theme2')) {
              themeType = 'job-search-theme2'
            }
            const jobDetailsAttributes = document.querySelector('#job-details-attributes').dataset['jobdetailsattributes'];

            const searchResults = await fetch(`${localePrefix}/api/v1/job-search-split-screen-widget/${themeType}?${page ? `page=${page}&` : ''}${config}&jobDetailsAttributes=${jobDetailsAttributes}&${filters}`);
            let url = new URL(window.location.href);
            if (page == 1) {
              const query = filters ? `?${filters}` : '';
              window.history.replaceState(null, null, `${url.origin}${url.pathname}${query}`);
            } else {
              const query = filters ? `?${filters}&page=${page}` : `?&page=${page}`;
              window.history.replaceState(null, null, `${url.origin}${url.pathname}${query}`);
            }
            return searchResults.text();
          } catch (e) {
            console.error(e);
          }
          return;
        }

        async function getJob(jobId) {
          const jobDetailsAttributes = document.querySelector('#job-details-attributes').dataset['jobdetailsattributes'];

          try {
            const searchResults = await fetch(`${localePrefix}/api/v1/job-search-split-screen-widget/job-details?id=${jobId}&jobDetailsAttributes=${jobDetailsAttributes}`);
            if(searchResults && searchResults.ok)
              return searchResults.text();
            return '';
          } catch (error) {
            console.log(error)
          }
          return '';
        }

        function renderJobsResults(htmlString) {
          try {
            const htmlDoc = document.createElement('html');

            // Validate new doc
            if (!htmlDoc) return;
            htmlDoc.innerHTML = htmlString
            const oldSplitScreenBody = searchForm.querySelector('#split-screen-body');
            const splitScreenNoJobsBody = searchForm.querySelector('#split-screen-no-jobs-body');
            const newSplitScreenBody = htmlDoc.querySelector('#split-screen-body');
            const newJobDetails = htmlDoc.querySelector('#jobDetails');
            if (newSplitScreenBody) {
              oldSplitScreenBody.innerHTML = newSplitScreenBody.innerHTML;
              const valueButton = toggleMapViewButton?.textContent;
              const jobDetailsElement = document.getElementById("jobDetails");
              const mapViewElement = document.getElementById("mapView");
              if (valueButton && valueButton.trim() === __t['jobSearch.hideMapLabel'] && mapViewElement) {
                jobDetailsElement && (jobDetailsElement.style.display = "none");
                mapViewElement && (mapViewElement.style.display = "block");
              }
            }

            if (newJobDetails) {
              const jobData = document.querySelector('#job-data');
              //updatePageUrl();
              updatePageUrl(jobData.dataset['slug'], false);
              addJobDetailBackBtnListener();
              addJobTabsListeners();
              updateQuickApplyWidgetContents();
              addQuickApplySubmitEvent();
              //initQuickApplyRecaptcha();
            }

            const jobSearchFilterResult = searchForm.querySelector('#job-search__filters__results-count')
            if (jobSearchFilterResult) {
              jobSearchFilterResult.innerHTML = htmlDoc.querySelector('#job-search__filters__results-count').innerHTML;
            }
            // Update job cards
            const joblistList = searchForm.querySelector('#jobs-list__list')
            if (joblistList) {
              joblistList.innerHTML = htmlDoc.querySelector('#jobs-list__list').innerHTML;
              addJobLinksListener();
            }

            const controlsLabels = searchForm.querySelector('#job-search__filters__info__controls__labels');
            if (controlsLabels) {
              controlsLabels.innerHTML = htmlDoc.querySelector('#job-search__filters__info__controls__labels').innerHTML;
            }
            const jobsMapInfoString = htmlDoc.querySelector('#api-data').getAttribute('data-jobsmapinfo')
            const jobsMapInfo = JSON.parse(jobsMapInfoString);
            if (jobsMapInfo && jobsMapInfo.length) {
              oldSplitScreenBody.classList.remove('hidden');
              splitScreenNoJobsBody.classList.add('hidden');
              window.initializeMap(jobsMapInfo);
            } else {
              const noJobsBody = htmlDoc.querySelector('#split-screen-no-jobs-body');
              splitScreenNoJobsBody.innerHTML = noJobsBody.innerHTML;
              splitScreenNoJobsBody.classList.remove('hidden');
              oldSplitScreenBody.classList.add('hidden');
            }

            markSavedJobs();
          } catch (err) {
            console.log(err);
          }
        }


        function renderJobDetailsResults(htmlString) {
          try {
            const jobDetails = searchForm.querySelector('#jobDetails');
            if (jobDetails && htmlString) {
              jobDetails.innerHTML = htmlString;
              const data = jobDetails.querySelector('#job-data');
              // if(data && data.dataset && data.dataset.jobtitle) {
              //   document.title = data.dataset.jobtitle;
              // }
              addJobDetailBackBtnListener();
              addJobTabsListeners();
              // addFavoriteListener();
              const saveIcons = searchForm.querySelectorAll('.btn-favorite');
              saveJob(saveIcons)
              addSavedJobEventCallback(saveIcons);
              updateQuickApplyWidgetContents();
              addQuickApplySubmitEvent();
              //initQuickApplyRecaptcha();
            }
            const jobDetailsContainer = searchForm.querySelector('.job-detail-container');
            const scrollTop = document.scrollTop || window.scrollY;
            if (jobDetailsContainer.offsetTop < scrollTop) {
              jobDetailsContainer.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
          } catch (err) {
            console.log(err);
          }
        }

        function updateQuickApplyWidgetContents() {
          const jobDetails = searchForm.querySelector('#jobDetails');
          // Update quick job apply title
          const quickApplyTitle = document.querySelector('#quick-job-apply-title');
          const quickApplyTitlePlaceholder = jobDetails.querySelector('#quick-job-apply-title-placeholder');
          if (quickApplyTitle && quickApplyTitlePlaceholder) {
            quickApplyTitlePlaceholder.innerHTML = quickApplyTitle.innerHTML;
          }
          // Update quick job apply Terms of Service
          const quickApplyTerms = document.querySelector('#quick-job-apply-terms-of-service');
          const quickApplyTermsPlaceholder = jobDetails.querySelector('#quick-job-apply-terms-of-service-placeholder');
          if (quickApplyTerms && quickApplyTermsPlaceholder) {
            quickApplyTermsPlaceholder.innerHTML = quickApplyTerms.innerHTML;
          }
          // Update quick job apply Success message
          const quickApplySuccess = document.querySelector('#quick-job-apply-post-submission-message');
          const quickApplySuccessPlaceholder = jobDetails.querySelector('#quick-job-apply-post-submission-message-placeholder');
          if (quickApplySuccess && quickApplySuccessPlaceholder) {
            quickApplySuccessPlaceholder.innerHTML = quickApplySuccess.innerHTML;
          }
        }

        function addQuickApplySubmitEvent() {
          // Validate jobDetails (Present only if exist matching jobs)
          const jobDetails = searchForm.querySelector('#jobDetails');
          if(!jobDetails) return;
          const submitQuickApplyForm = jobDetails.querySelector("#quickapply-submit");

          if (!submitQuickApplyForm) return;

          const redirectToAccount = jobDetails.querySelector("#quickapply-account");
          const companyData = jobDetails.querySelector("#quickResumeApplyDetails").dataset;
          const multiselect = jobDetails.querySelectorAll(".multiselect");
          const singleselect = jobDetails.querySelectorAll(".singleselect");
          const ratingButtons = document.getElementsByName("rating");
          const textareaField = jobDetails.querySelectorAll(".textareaField");
          const textInput = jobDetails.querySelectorAll(".textInputArea");

          const MinTextCount = jobDetails.querySelectorAll('.setMinCount')
          const questionRequired = jobDetails.querySelectorAll(".questionRequired");
          const apiCallData = jobDetails.querySelectorAll(".apiData");
          const apiResponse = Array.from(apiCallData).map((apis) =>
            apis.getAttribute("id")
          );


          const requiredQuestions = [];
          let selectedAnswerIDs = [];
          let selectedOption = [];
          let ratingValue = [];
          let TextValue = [];

          for (var i = 0; i < MinTextCount.length; i++) {
            MinTextCount[i].innerHTML = 0;
          }

          document.addEventListener('click', (event) => {
            multiselect.forEach((select) => {
              const dropdownDiv = select.querySelector('.dropdown');
              if (dropdownDiv.style.display === 'block' && !select.contains(event.target)) {
                dropdownDiv.style.display = 'none';
              }
            });

            singleselect.forEach((select) => {
              const dropdownDiv = select.querySelector('.dropdown');
              if (dropdownDiv.style.display === 'block' && !select.contains(event.target)) {
                dropdownDiv.style.display = 'none';
              }
            });

          });

          const quickApplyForm = jobDetails.querySelector("#quickapply-form");
          quickApplyForm && quickApplyForm.addEventListener('submit', (evt) => {
            evt.preventDefault();
          });

          Array.from(questionRequired).map((req) => {
            let obj = {}
            obj['id'] = req.getAttribute('id')
            obj['type'] = req.getAttribute('type')
            if (req.getAttribute('minLength') && req.getAttribute('minLength').length > 0) {
              obj['minlength'] = parseInt(req.getAttribute('minLength'))
            }
            requiredQuestions.push(obj)
          });

          if (apiResponse.length > 0) {

            multiselect.forEach(function (select) {
              select?.addEventListener("click", event => {
                var checkbox = []
                var questionId = select.getAttribute('question')
                var selectedDiv = event.currentTarget.querySelector("#selected");
                var dropdownDiv = event.currentTarget.querySelector(".dropdown");
                var options = event.currentTarget.querySelectorAll('.dropdown input[type="checkbox"]');
                var Values = event.currentTarget.querySelectorAll('.dropdown input[type="checkbox"]');
                var options1 = event.currentTarget.querySelectorAll('.dropdown li');
                options1.forEach((item) => {
                  // Get the input element within the clicked list item
                  checkbox.push(item.querySelector('input[type="checkbox"]'));
                });


                dropdownDiv.style.display = dropdownDiv.style.display === "block" ? 'none' : 'block';
                let checkedValues = []

                let multiselectOptions = {}

                options1.forEach(option => {
                  option.addEventListener('click', event1 => {
                    var checkboxSelect = option.querySelector('input[type="checkbox"]')
                    if (checkboxSelect && (event1.target.id == 'wholediv' || event1.target.id == 'labelName')) {
                      // Toggle the checkbox state
                      checkboxSelect.checked = !checkboxSelect.checked;
                    }

                    const checkedOptions = Array.from(checkbox)
                      .filter(option => option.checked)
                      .map(option => option.id);
                    if (checkedOptions.length == 0) {
                      selectedDiv.textContent = __t['quickApply.multiSelectPlaceholder']
                    }
                    else {
                      selectedDiv.textContent = checkedOptions.join(', ');
                    }


                    checkedValues = Array.from(checkbox).filter(option => option.checked).map(option => option.value);
                    let test = checkedValues

                    let exists = false;
                    for (i = 0; i < selectedAnswerIDs.length; i++) {
                      if (selectedAnswerIDs[i]['questionId'] == questionId) {
                        exists = true
                        selectedAnswerIDs[i]['value'] = checkedValues.map(str => parseInt(str))
                      }
                    }
                    if (selectedAnswerIDs.length == 0 || !exists) {
                      multiselectOptions['questionId'] = questionId
                      multiselectOptions['value'] = checkedValues.map(str => parseInt(str))
                      multiselectOptions['type'] = 'multiselect'
                      selectedAnswerIDs.push(multiselectOptions);
                    }
                  });

                });


              })
            });

            ratingButtons.forEach(function (ratingButton) {
              ratingButton?.addEventListener("click", function () {
                if (this.checked) {
                  let ratingArray = {}
                  let question = ratingArea.getAttribute('question')
                  let exists = false;
                  for (i = 0; i < ratingValue.length; i++) {
                    if (ratingValue[i]['questionId'] == question) {
                      exists = true
                      ratingValue[i]['value'] = checkedValues.map(str => parseInt(str))
                    }
                  }
                  if (ratingValue.length == 0 || !exists) {
                    ratingArray['questionId'] = question
                    ratingArray['value'] = [this?.value]
                    rating['type'] = 'rating'
                    ratingValue.push(ratingArray)
                  }
                }
              });
            });
            singleselect.forEach(function (selectElem) {
              selectElem?.addEventListener("click", event => {
                var checkbox = []
                var question = selectElem.getAttribute('question')
                var dropdownDiv = event.currentTarget.querySelector(".dropdown");
                var selectedDiv = event.currentTarget.querySelector("#selected");
                dropdownDiv.style.display = dropdownDiv.style.display === "block" ? 'none' : 'block';
                var options = event.currentTarget.querySelectorAll('.dropdown li')
                var value = ''
                options.forEach(option => {
                  option.addEventListener('click', event1 => {
                    var input = option.querySelector('input[type="hidden"]')
                    option.style.backgroundColor = 'lightgrey';
                    var name = input.getAttribute('id');
                    value = input.getAttribute('value').trim();
                    if (name != null) {
                      selectedDiv.innerHTML = name
                    }
                    if (value.length > 0) {

                      let selectedOptionObject = {}

                      let updated = false;
                      let exists = false;
                      for (i = 0; i < selectedOption.length; i++) {
                        if (selectedOption[i]['questionId'] == question) {
                          exists = true
                          selectedOption[i]['value'] = [parseInt(value)]
                        }
                      }
                      if (!exists) {
                        selectedOptionObject['questionId'] = question
                        selectedOptionObject['value'] = [parseInt(value)]
                        selectedOptionObject['type'] = 'rating'
                        selectedOption.push(selectedOptionObject)
                      }

                    } else {
                      selectedOption = [];
                    }

                    for (var i = 0; i < options.length; i++) {
                      var input = options[i].querySelector('input[type="hidden"]')
                      if (input.getAttribute('value').trim() != value) {
                        options[i].style.backgroundColor = 'white';
                      }
                    }
                  })
                })

              });
            });

            if (textareaField) {

              textInput.forEach(function (textinp) {
                textinp?.addEventListener("input", function () {
                  let id = textinp.getAttribute("question") + "count"
                  const count = document.getElementById(id);
                  let text = {}

                  let updated = false;
                  for (var i = 0; i < TextValue.length; i++) {
                    if (TextValue[i]['questionId'] == textinp.getAttribute("question")) {
                      TextValue[i]['value'] = textinp.value
                      updated = true
                    }
                  }
                  if (!updated) {
                    text['questionId'] = textinp.getAttribute("question")
                    text['value'] = textinp.value
                    text['type'] = 'text'
                    text['minlength'] = textinp.getAttribute('minlength')
                    text['maxlength'] = textinp.getAttribute('maxlength')

                    TextValue.push(text)
                  }

                  if (count) {
                    count.innerHTML = textinp?.value?.length;
                  }
                }
                );
              });

            }

          }

          submitQuickApplyForm.addEventListener("click", async (evt) => {
            evt.preventDefault();
            const captchaErrorMessage = jobDetails.querySelector("#captchaErrorMessage");
            QuestionnaireValidated = true;
            if (captchaErrorMessage) {
              captchaErrorMessage.style.display = "none";
            }

            var phone = "";
            var file = null;
            var terms = false;
            var notifications ={ "WHATSAPP": false }
            const firstName = jobDetails.querySelector("#firstName");
            const lastName = jobDetails.querySelector("#lastName");
            const emailInput = jobDetails.querySelector("#emailInput");
            const termsField = jobDetails.querySelector("#quickapply-terms");
            const smsOptIn = jobDetails.querySelector('#smsOptIn')
            const phoneField = jobDetails.querySelector("#phone");
            const resumeField = jobDetails.querySelector("#quickapply-resume");
            const apiData = document.getElementById("api-data").dataset;
            const companyCode = apiData['companycode'];

            phone = phoneInputQuickApply.getNumber(
              intlTelInputUtils.numberFormat.E164
            );
            const data = document.getElementById("job-data").dataset;
            const jobId = data["jobid"];

            if (
              companyData["resumeuploadrequired"] == "01" ||
              (companyData["resumeuploadrequired"] == "02" &&
                resumeField.files.length > 0)
            ) {
              file = resumeField.files[0];
            }

            const MAX_SIZE = 5242880;
            if (file) {
              resumeField.setCustomValidity("");
            }
            if (file && file.size > MAX_SIZE) {
              displayValidationMessage(
                resumeField,
                __t['quickApply.resumeErrorFileSize']
              );
              return;
            }
            if (companyData["termsandservices"] == "true") {
              terms = termsField.checked;
            }

            const questionElements = jobDetails.querySelectorAll(".question");
            const questionData = Array.from(questionElements).map(
              (questionElement) => {
                const [questionID, questionType] = questionElement
                  .getAttribute("id")
                  .split("_");
                return [questionID, questionType];
              }
            );
            if (apiResponse.length > 0) {
              if (questionData.length > 0) {
                questionnaireHeading.innerHTML = __t['quickApply.questionnaireDefaultTitle'];
                questionnaireSection?.classList.add("block");
              } else {
                questionnaireSection?.classList.remove("block");
                questionnaireHeading.innerHTML = "";
              }
            }

            var questionResponseDataArray = [];
            questionData.forEach((data) => {
              const questionID = data[0];
              const questionType = data[1];

              if (
                questionType === "06") {
                var answerList = fetchAnswer(ratingValue, questionID, questionType)
                const questionObject1 = {
                  questionID: questionID,
                  userQuestionResponse: {
                    userAnswerList: answerList,
                    questionTextResponse: "",
                  },
                };
                questionResponseDataArray.push(questionObject1);
              } else if (
                questionType === "01"
              ) {
                var answerList = fetchAnswer(selectedAnswerIDs, questionID, questionType)
                const questionObject2 = {
                  questionID: questionID,
                  userQuestionResponse: {
                    userAnswerList: answerList,
                    questionTextResponse: "",
                  },
                };
                questionResponseDataArray.push(questionObject2);
              } else if (
                questionType === "03"
              ) {
                var answerList = fetchAnswer(selectedOption, questionID, questionType)
                const questionObject3 = {
                  questionID: questionID,
                  userQuestionResponse: {
                    userAnswerList: answerList,
                    questionTextResponse: "",
                  },
                };
                questionResponseDataArray.push(questionObject3);
              } else if (
                questionType === "04" ||
                questionType === "02" ||
                (questionType === "11")
              ) {
                var answerList = fetchAnswer(TextValue, questionID, questionType)
                const questionObject4 = {
                  questionID: questionID,
                  userQuestionResponse: {
                    userAnswerList: [],
                    questionTextResponse: answerList,
                  },
                };
                questionResponseDataArray.push(questionObject4);
              }
            });


            ValidateQuickApplyQuestionnaire(questionRequired, questionResponseDataArray, requiredQuestions);
            let isValidated = validateQuickApplyFields(
              firstName,
              lastName,
              emailInput,
              termsField,
              phoneField,
              resumeField,
              file,
              phoneInputQuickApply
            );
            
            if(smsOptIn){
              notifications.SMS = smsOptIn.checked
            }


            if (isValidated && QuestionnaireValidated) {

              const userData = {
                userName: emailInput?.value,
                firstName: firstName?.value,
                lastName: lastName?.value,
                email: emailInput?.value,
                password: "",
                phone: phone,
                phoneNumberValid: true,
                companyCode,
                sourceType: "",
                referralUrl: "",
                referralCode: "",
                userDeviceAppTkn: "",
                duplicateCheckRequired: true,
                isEmailSystemGenerated: true,
                completeRegistration: false,
                userAgreement: terms,
                marketingEmailFlag: false,
                enabled: true,
                notificationTypeMap:notifications,
              };

              const questionnaireData = {
                userId: 0,
                jobPostingId: jobId,
                questionResponseData: questionResponseDataArray,
                referralCode: "",
              };

              const formData = new FormData();
              formData.append("user", JSON.stringify(userData));


              if (questionnaireData.questionResponseData != null && questionnaireData.questionResponseData.length > 0) {
                formData.append(
                  "questionnaireInfo",
                  JSON.stringify(questionnaireData)
                );
              }

              formData.append("jobPostingId", jobId);

              formData.append("companyCode", companyCode);

              formData.append("userAgreement", true);

              if (utmTrackerId) {
                formData.append('utmTrackerId', utmTrackerId);
              }

              if (file != null) {
                formData.append("resumefile", file);
              }
              formData.append(
                "resume",
                `{"resumename":"","resumeLink":"","jobpostingid": ${jobId}}`
              );
              formData.append("resumeUploadRequired", companyData['resumeuploadrequired'])
              formData.append('userAgent',"WL-CMS")

              // formData.append("context", "QUICK_APPLY");
              var spinner = jobDetails.querySelector("#quick-apply-spinner");
              var overlay = jobDetails.querySelector("#quick-apply-overlay");

              overlay.style.display = "block";
              spinner.style.display = "block";
              var response = await quickJobApplyJobDetails(formData, companyData['resumeuploadrequired']);
              if (response.success == true) {
                var isMobileView=  window.innerWidth;
                if(isMobileView<1200){
                  setTimeout(function() {
                    document.documentElement.scrollTop = 0;
                    document.body.scrollTop = 0;
                }, 100);

                }

                jobDetails.querySelector("#firstName").value = "";
                jobDetails.querySelector("#lastName").value = "";
                jobDetails.querySelector("#phone").value = "";
                if (apiResponse.length > 0) {
                  // jobDetails.querySelector(".textInputArea").value = "";
                  selectedAnswerIDs = [];
                  selectedOption = [];
                  ratingValue = [];
                }

                overlay.style.display = "none";
                spinner.style.display = "none";
                if (
                  companyData["resumeuploadrequired"] == "01" ||
                  (companyData["resumeuploadrequired"] == "02" &&
                    jobDetails.querySelector("#quickapply-resume").files
                      .length > 0)
                ) {
                  jobDetails.querySelector("#quickapply-resume").value = null;
                }
                if (companyData["termsandservices"] == "true") {
                  termsField.checked = false;
                }
                redirectToAccount.setAttribute('data-username', emailInput?.value);
                jobDetails.querySelector("#quickResumeApply").remove();
                jobDetails.querySelector("#post-data").style.display = "block";

                const currentURL = window.location.href;
                const newURL = new URL(currentURL);
                // if(!externalUrl){
                  newURL.searchParams.set('successfullyApplied', 'true');
                // }
                window.history.replaceState(null, '', newURL.toString());

                window.scrollTo(0, stickyContainerOffset || 0);
                console.log("Job Apply Submitted", "Job Apply Submitted successfully!");

                const questionTemplateId = companyData["questiontemplateid"];

                // Track Click on Submit Quick Apply Button
                var jobData = document.querySelector("#job-data");
                logWLAnalyticsEvent(`Job Apply Submitted`, {
                  userId: response.userId,
                  jobPostingId: jobData?.dataset?.jobid,
                  jobTitle: jobData?.dataset?.jobtitle,
                  quickApply: true,
                  resumeAttached: file != null,
                  questionnaireId: questionTemplateId,
                  loggedIn: false,
                });

                if(jobData?.dataset && response.userId)
                  jobData.dataset.userId = response.userId;

              } else {
                const errorMessage = response.split(".")[0];

                spinner.style.display = "none";
                overlay.style.display = "none";

                if (!errorMessage) return false;
                const lowerErrorMessage = errorMessage.toLowerCase();
                if (
                  lowerErrorMessage.indexOf(
                    "this email address is already in use"
                  ) >= 0
                ) {
                  jobDetails.querySelector(
                    "#quick-apply-existing-user"
                  ).style.display = "block";
                  appendLoginUrl()
                  oldEmail = emailInput.value
                } else if (
                  lowerErrorMessage.indexOf(
                    "you have already applied for this job"
                  ) >= 0
                ) {
                  jobDetails.querySelector("#alreadyApplied").style.display =
                    "block";
                } else if (lowerErrorMessage.indexOf("email")>= 0) {
                  displayValidationMessage(
                    jobDetails.querySelector("#emailInput"),
                    errorMessage
                  );
                } else if (lowerErrorMessage.indexOf("phone") >= 0) {
                  displayValidationMessage(
                    jobDetails.querySelector("#phone"),
                    errorMessage
                  );
                } else if (lowerErrorMessage.indexOf("first name") >= 0) {
                  displayValidationMessage(
                    jobDetails.querySelector("#firstName"),
                    errorMessage
                  );
                } else if (lowerErrorMessage.indexOf("last name") >= 0) {
                  displayValidationMessage(
                    jobDetails.querySelector("#lastName"),
                    errorMessage
                  );
                } else if (lowerErrorMessage.indexOf('resume') >= 0) {
                  displayValidationMessage(resumeField, response);
                }
              }
            }

            return false;
          });
          redirectToAccount.addEventListener("click", async (evt) => {
            const userName = evt.target.getAttribute('data-username');
            let locale = window.apos?.locale;
            let urlToOpen = `${baseUrl}/atsuser/v2/login?userName=${userName}&postQuickApplySignupAction=true&locale=${locale}`;
            let currentQueryParams = window.location.search;
            if(externalUrl){
              urlToOpen = externalUrl;
            }else{
              if (currentQueryParams) {
              currentQueryParams = currentQueryParams.substring(1);
              urlToOpen += `&${currentQueryParams}`;
             }
            }
            window.open(urlToOpen);
            // Track Click on Complete Account Now Button
            var jobData = document.querySelector("#job-data");
            logWLAnalyticsEvent("Complete Account Selected", {
              userId: jobData?.dataset?.userId,
            });
          });

        }

        function setupQuickApplyPhoneInput() {
          const companyData = jobDetails.querySelector("#quickResumeApplyDetails").dataset;

          const phoneInputFieldQuickApply = document.querySelector("#phone");
          phoneInputQuickApply = window.intlTelInput(
            phoneInputFieldQuickApply,
            {
              initialCountry: companyData.phonedefaultcountry,
              utilsScript:
                "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/utils.js",
            }
          );

          phoneInputFieldQuickApply.addEventListener("input", () => {
            const currentInputValue = phoneInputFieldQuickApply?.value;
            const formattedPhoneNumber = formatPhoneNumber(currentInputValue);
            phoneInputFieldQuickApply.value = formattedPhoneNumber;
          });
        }

        function formatPhoneNumber(phoneNumber) {
          phoneNumber = phoneNumber.replace(/\D/g, "");
          if (phoneNumber.length <= 3) {
            return phoneNumber;
          } else if (phoneNumber.length <= 6 && !companyData.phonedefaultcountry === 'GB') {
            return ` (${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
          }
          else if (companyData.phonedefaultcountry === 'GB'){
            if (phoneNumber.length <= 7)
            {
              return ` ${phoneNumber.slice(0, 3)} ${phoneNumber.slice(3)}`
            }else
          {
            return `${phoneNumber.slice(0, 3)} ${phoneNumber.slice(
              3,
              7
            )} ${phoneNumber.slice(7,11)}`
          }}
          else {
            return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(
              3,
              6
            )} ${phoneNumber.slice(6,10)}`;
          }
        }

        function ValidateQuickApplyQuestionnaire(questionRequired, questionResponseDataArray, requiredQuestions) {
          for (var i = 0; i < requiredQuestions.length; i++) {
            for (var j = 0; j < questionResponseDataArray.length; j++) {
              if (questionResponseDataArray[j].questionID == requiredQuestions[i]['id']) {
                let answerArray = questionResponseDataArray[j].userQuestionResponse
                let requiredArray = requiredQuestions[i]
                if (requiredArray['type'] == '01' && (typeof answerArray.userAnswerList == 'undefined' || answerArray.userAnswerList.length == 0)) {
                  displayErrorMessage(questionResponseDataArray[j].questionID + "multiError", __t['quickApply.multiselectErrorRequired']);
                }
                else if (requiredArray['type'] == '03' && (typeof answerArray.userAnswerList == 'undefined' || answerArray.userAnswerList.length == 0)) {
                  displayErrorMessage(questionResponseDataArray[j].questionID + "singleError", __t['quickApply.singleSelectErrorRequired']);
                }
                else if (requiredArray['type'] == '06' && (typeof answerArray.userAnswerList == 'undefined' || answerArray.userAnswerList.length == 0)) {
                  displayErrorMessage(questionResponseDataArray[j].questionID + "ratingError", __t['quickApply.ratingErrorRequired']);

                }

                else if ((requiredArray['type'] == '04' || requiredArray['type'] == '11' || requiredArray['type'] == '02') &&
                  (typeof answerArray.questionTextResponse == 'undefined' || answerArray.questionTextResponse.length == 0 || (typeof requiredArray.minlength != 'undefined' && answerArray.questionTextResponse.length >= requiredArray.minlength))) {
                  displayErrorMessage(questionResponseDataArray[j].questionID + "shortTextError", __t['quickApply.textInputErrorInvalid']);

                }
              }


            }
          }
        }

        function validateQuickApplyFields(
          firstName,
          lastName,
          emailInput,
          termsField,
          phoneField,
          resumeField,
          file,
          phoneInputQuickApply
        ) {
          const companyData = jobDetails.querySelector("#quickResumeApplyDetails").dataset;
          var allowedTypes = companyData["resumetypesallowed"].split(",");

          firstName.setCustomValidity("");
          lastName.setCustomValidity("");
          phoneField.setCustomValidity("");

          if (file) {
            resumeField.setCustomValidity("");
          }
          if (!(firstName?.value?.length > 0)) {
            setTimeout(() => {
              displayValidationMessage(
                firstName,
                __t['global.firstNameErrorRequired']
              );
            }, 500);
            return false;
          }

          if (!(lastName?.value?.length > 0)) {
            setTimeout(() => {
              displayValidationMessage(lastName, __t['global.lastNameErrorRequired']);
            }, 500);
            return false;
          }

          if (
            !(emailInput?.value?.length > 0 && validateEmail(emailInput?.value))
          ) {
            displayValidationMessage(
              emailInput,
              emailInput?.value?.length
                ? __t['global.emailErrorInvalid']
                : __t['global.emailErrorRequired'],
              'inputValidation'
            );
            return false;
          }

          if (
            !(
              phoneField?.value?.length > 0 &&
              phoneInputQuickApply.isValidNumber()
            )
          ) {
            displayValidationMessage(
              phoneField,
              phoneField?.value?.length
                ? __t['quickApply.phoneErrorInvalid']
                : __t['quickApply.phoneErrorRequired'],
              'inputValidation'
            );
            return false;
          }

          if (companyData["resumeuploadrequired"] === "01") {
            if (resumeField.files.length > 0) {
              if (!allowedTypes.includes(resumeField.files[0].type)) {
                setTimeout(() => {
                  displayValidationMessage(
                    resumeField,
                    __t['quickApply.resumeErrorInvalid']
                  );
                }, 500);
                return false;
              }
            } else {
              setTimeout(() => {
                displayValidationMessage(
                  resumeField,
                  __t['quickApply.resumeSubmit'],
                  __t['quickApply.resumeErrorRequired']
                );
              }, 500);
              displayValidationMessage(resumeField, __t['quickApply.resumeErrorRequired']);
              return false;
            }
          } else if (
            companyData["resumeuploadrequired"] === "02" &&
            resumeField.files.length > 0
          ) {
            if (!allowedTypes.includes(resumeField.files[0].type)) {
              setTimeout(() => {
                displayValidationMessage(
                  resumeField,
                  __t['quickApply.resumeErrorInvalid']
                );
              }, 500);
              return false;
            }
          }

          if (companyData["termsandservices"] == "true") {
            termsField.setCustomValidity("");
            if (!termsField.checked) {
              setTimeout(() => {
                displayValidationMessage(
                  termsField,
                  __t['quickApply.termsRequired']
                );
              }, 500);
              return false;
            }
          }
          if (companyData["recaptcharequired"] == "true") {
            if (
              !(window.grecaptcha && window.grecaptcha.getResponse().length !== 0) &&
              captchaErrorMessage
            ) {
              captchaErrorMessage.style.display = "block";
              return false;
            }
          }

          return true;
        }


function addDropDownInitialLoad(parent, input, arr, filterSlugAlias, filterName, fieldType, displayType,filterLabel) {
  let currentFocus;

    const value = null
    // closeAllLists();
    currentFocus = -1;

    var parentNode = parent.querySelector('.input-group');
    var inputElementId= input.getAttribute("id");

    alreadyReplaced = false



    for (let i = 0; i < arr.length; i++) {
        const dropDownField = addDropDownField1(arr[i].display, arr[i].value, filterSlugAlias, filterName, fieldType, displayType,input,filterLabel);

    }

  function addDropDownField1(display, value, filterSlugAlias, filterName, fieldType, displayType,input,filterLabel) {

    var urlParams = getAllInputValues()
    var checked=false
    var selected = false;
    var copyDisplay=display
    var params=urlParams.split('&')
    for(var i=0;i<params.length;i++){
      checked=false
      var values=params[i].split("=")
      if(values[0].toLowerCase().trim()==filterSlugAlias.toLowerCase()){
          if((values[1].trim()==display.replace(/ /g,"%20").trim())|| (values[1].trim()==display.replace(/ /g,"+").trim())){
            var index=-1
            for(var j=0;j<checkedFilters.length;j++){
              if(checkedFilters[j]["filterLabel"]==filterLabel){
                index=j
              }
            }

          if(index!=-1 && displayType=='multi-select'){
            if( !checkedFilters[index].values.includes(copyDisplay)){
              checkedFilters[index].values.push(copyDisplay)
              checked=true
            }

          }
          else if(index==-1 && displayType=='multi-select'){

            checkedFilters.push({"filterLabel":filterLabel,"values":[copyDisplay]})
            checked=true

          }
          else if(displayType=='select'){
            checkedFilters.push({"filterLabel":filterLabel,"values":[copyDisplay]})
            selected = true
          }

          }
      }

      var isMobileView=  window.innerWidth;
        if(checked && isMobileView>1200){
      multiSelectPlaceHolder( input, null,display,filterLabel,null)

    }
    else if(selected && isMobileView>1200){
      singleSelectPlaceHolder(input,null,display,filterLabel,null)

    }

  }
}
}


        function updateSkillsPlaceHolder(){
          const multiSearches = searchForm.querySelectorAll('.filters-collapse');

          multiSearches.forEach((multiSearch) => {
            if (!multiSearch.querySelector('.multi-search-field')) return;

          const inputField = multiSearch.querySelector('input[type=text]');
          const selectField = multiSearch.querySelector('select');
          var filterValues = [];
          selectField.querySelectorAll('option').forEach(option =>
            filterValues.push({value: option.value, display: option.text})
          );

          const filterSlugAlias = selectField.getAttribute('data-filterslugalias');
          const filterName = selectField.getAttribute('data-filtername');
          const fieldType = selectField.getAttribute('data-fieldtype');
          const displayType = selectField.getAttribute('data-displaytype');
          const filterLabel= selectField.getAttribute('data-label')
          var remainingfilters=[]
          if( filterName=='SkillType.skillTypeId'){

          for(var i=0;i<checkedFilters.length;i++){
              if(checkedFilters[i]["filterLabel"]==filterLabel){
              return
            }
            remainingfilters.push(checkedFilters[i])
          }
          }

          checkedFilters=remainingfilters
          if(filterName=='SkillType.skillTypeId'){
          addDropDownInitialLoad(multiSearch.parentNode, inputField, filterValues, filterSlugAlias, filterName, fieldType, displayType,filterLabel);

          }

          });
          }
        /**
         * Job Alerts
         */
        const jobAlertsToggle = searchForm.querySelector('#job-alerts-toggle');
        if (jobAlertsToggle) {

          const jobAlertsModal = searchForm.querySelector('.job-alerts-modal');
          jobAlertsToggle.addEventListener('change', () => {
            if (jobAlertsToggle.checked) {
              jobAlertsModal.classList.remove('hidden');
            } else {
              jobAlertsModal.classList.add('hidden');
            }
          });

          const jobAlertsSubmit = searchForm.querySelector('#job-alerts-save-button');
          if (jobAlertsSubmit) {
            jobAlertsSubmit.addEventListener('click', onJobAlertsSubmit)
          }

          const jobAlertsCancel = searchForm.querySelector('#job-alerts-cancel-button');
          if (jobAlertsCancel) {
            jobAlertsCancel.addEventListener('click', onCloseJobAlertsModal)
          }

          const jobAlertsOk = searchForm.querySelector('#job-alerts-ok-button');
          if (jobAlertsOk) {
            jobAlertsOk.addEventListener('click', onFinishJobAlerts);
          }

          function onCloseJobAlertsModal() {
            if (jobAlertsModal) {
              jobAlertsToggle.checked = false;
              jobAlertsModal.classList.add('hidden');
            }
          }

          async function getJobAlertFilterParams() {
            const urlParams = getAllInputValues()
            var paramArray = urlParams.split('&')
            var req = {}
            for (var i = 0; i < paramArray.length; i++) {
              const [key, value] = paramArray[i].split('=');
              if (req[key]) {
                req[key] += "," + decodeURIComponent(value);
              } else {
                req[key] = decodeURIComponent(value)
              }

            }
            var fillers = await getFilters();
          var filters = fillers.data.jobFilterMetaDataVOList
            const filterArgs = Object.entries(req);
            // Format the args for the job search API
            const formattedFilterArgs = filterArgs.map(([key, _value]) => {
              const filter = filters.find((filter) => filter.slugAlias === key);
              if (filter && _value) {
                if (filter.displayType === 'salaryrange' && (_value === 0 || _value === '0')) return;

                let value = _value;
                if (Array.isArray(_value)) {
                  const values = _value.map((x) => {
                     const selectedOption = filter.filterValues.find((option) => option.label === x)
                     if (selectedOption) {
                       return selectedOption.value
                     }
                  });
                  value = values.join(',');
                } else if (filter.filterValues) {
                  const selectedOption = filter.filterValues.find((option) => option.label.replace(/\n/g, '') === _value)
                  if (selectedOption) {
                    value = selectedOption.value
                  }
                }
                if (filter.slugAlias === 'category') {
                  value = JSON.stringify({categoryIds: value.split(',')})
                }
                if (value)
                  return {
                    name: filter.name,
                    label: filter.label,
                    displayType: filter.displayType,
                    fieldType: filter.fieldType,
                    value
                  }
              }
            }).filter((filterArg) => !!filterArg);

            const sortFilter = filters.find(filter => filter.name === 'JobPosting.SortCriteria');
            const sortFilterDefaultValue = sortFilter?.filterValues[0]?.value
            const selectedSortFilter = req['sort-by'] || sortFilterDefaultValue
            const extraConfig = sortFilter?.extraConfig || {}


            const sortCriteria = {
              sortField: selectedSortFilter,
              sortOrderAsc: extraConfig[selectedSortFilter] === 'asc' ? true : false
            };

            const location = req['location'];
            const radius = req['within'];
            const latitude = location ? req['location-lat'] : '';
            const longitude = location ? req['location-lng'] : '';


            var locationparam = {
              location,
              latLong: {latitude, longitude},
              locationType: location ? req['location-type'] : '',
              locShortName: location ? req['location-short'] : '',
              radius: radius
            }
            const jobFilters = {formattedFilterArgs, sortCriteria, locationparam}
            return jobFilters
          }

          var urlParams = getAllInputValues()
          var paramArray = urlParams.split('&')
          if (paramArray.length > 0) {
            paramArray.forEach(filter => {
              const [key, value] = filter.split('=');
              if (key == 'location' || key == 'job-search') {
                displayAlerts()
                return null
              }
            })

          }

          async function onJobAlertsSubmit() {
            const jobAlertsEmailInput = document.querySelector('#job-alerts-email-input');
            const termsAndConditions = searchForm.querySelector('#terms')
            const jobAlertName = searchForm.querySelector('#job-alerts-name-input')
            var frequency = document.querySelector('input[name="job-alert-frequency"]:checked').value
            jobAlertName.setCustomValidity('');
            if (jobAlertName.value.length < 3) {
              displayValidationMessage(jobAlertName, __t['jobAlert.nameErrorInvalid']);
              return null;
            } else if (!(jobAlertsEmailInput && jobAlertsEmailInput.value && validateEmail(jobAlertsEmailInput.value))) {
              displayValidationMessage(jobAlertsEmailInput, __t['jobAlert.emailErrorInvalid']);
              return null;
            } else if (!termsAndConditions.checked) {
              displayValidationMessage(termsAndConditions, __t['jobAlert.termsServiceErrorRequired']);
              return null
            } else {
              const filterValues = await getJobAlertFilterParams()

              const response = await createAlerts({
                email: jobAlertsEmailInput.value,
                name: jobAlertName.value,
                jobAlertFrequency: frequency,
                jobAlertConfigDetails: {
                  jobParamRequests: filterValues.formattedFilterArgs,
                  locationInfo: filterValues.locationparam,
                  sortCriteria: filterValues.sortCriteria,
                  text: ""
                }
              });
              if (!response.success) {
                if (response.errorMessage == 'You already have an account. Please log in to create a job alert.') {
                  searchForm.querySelector('#show-login-error-message').style.display = "block"
                } else {
                  searchForm.querySelector('#show-error-message').innerHTML = response.errorMessage
                }
                //  errorMessage.innerHTML= 'You already have an account. Please'+ <a href="https://google.com">+'log in'+ </a>+'to create a job alert.'
                return null;
              }

              const jobAlertsEmail = searchForm.querySelector('#job-alerts-email');
              if (jobAlertsEmail) {
                jobAlertsEmail.innerHTML = jobAlertsEmailInput.value;
              }
              const jobAlertsForm = searchForm.querySelector('.job-alerts__card.form');
              const jobAlertsSuccess = searchForm.querySelector('.job-alerts__card.hidden');
              jobAlertsForm.classList.add('hidden');
              jobAlertsSuccess.classList.remove('hidden');
              if (jobAlertsEmail && jobAlertsEmailInput) {
                jobAlertsEmail.innerHTML = jobAlertsEmailInput.value;
              }

              // Track Job Alert Creation
              logWLAnalyticsEvent('Job Alert Created', {
                jobAlertId: response.jobAlertId,
                jobAlertName: jobAlertName.value,
                jobAlertFrequency : frequency,
                loggedIn: false,
              });

              jobAlertsEmailInput.value = '';
              termsAndConditions.checked = false;
              jobAlertName.value = __t['jobAlert.nameDefaultValue']
              searchForm.querySelector('#dailyRadio').checked = true;

            }

          }
          function onFinishJobAlerts() {
            onCloseJobAlertsModal();
            jobAlertsToggle.classList.add('hidden');
            const jobAlertsLabel = searchForm.querySelector('#job-alerts-label');
            if (jobAlertsLabel) {
              jobAlertsLabel.innerHTML = 'Alerts saved';
            }
          }

          document.addEventListener('click', function (e) {
            if (!e.target.closest('.job-search__filters__switch')) {
              onCloseJobAlertsModal();
            }
          });
        }

        function validateEmail(email) {
          return String(email)
            .toLowerCase()
            .match(
              /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            );
        };

        function displayValidationMessage(field, message, inputValidation) {
          try {
            if (inputValidation) {
              field.focus();
            }
            setTimeout(() => {
              field.setCustomValidity(message || __t['global.requiredField']);
              field.reportValidity();
            }, 1000);
          } catch (err) {
            console.log(err);
          }
        };

        function fetchAnswer(answerArray, questionId, questionType) {
          if (answerArray.length > 0) {
            for (var i = 0; i < answerArray.length; i++) {
              if (questionId == answerArray[i]['questionId']) {
                return answerArray[i]['value']
              }
              else if (questionType == '01' || questionType == '06' || questionType == '03') {
                return []
              }
              else {
                return null
              }
            }
          }
          else if (questionType == '01' || questionType == '06' || questionType == '03') {
            return []
          }
          else {
            return ""
          }
        };


        function displayErrorMessage(errorContainer, message) {
          let errordiv = document.getElementById(errorContainer);
          let test = jobDetails.querySelectorAll('.singleselectErr')
          let errorMessage = errordiv.querySelector('.error-message');
          if (!errorMessage) {
            errorMessage = document.createElement('p');
            errorMessage.className = 'error-message';
            errorMessage.style.color = 'red';
            errorMessage.style.fontSize = '12px';
            errorMessage.style.marginTop = '6px';
            errordiv.appendChild(errorMessage);
          }
          QuestionnaireValidated = false;
          errorMessage.innerHTML = message;
          errorMessage.style.display = 'block'
          setTimeout(() => {
            errorMessage.style.display = 'none';
          }, 6000);

        };

        // Renders recaptcha for current job details
        function initQuickApplyRecaptcha() {
          const quickApplyParams = document.querySelector("#quickResumeApplyDetails");
          if(!quickApplyParams) return;
          const companyData = quickApplyParams.dataset;
          if (companyData && companyData["recaptcharequired"] == "true"
              && window && window.grecaptcha && window.grecaptcha.render) {
            window.grecaptcha.render("widgetId", {
              sitekey: companyData.recaptchaclientsidekey,
            });
          }
        };
        // Init recaptcha (as when loading page job details is already rendered)
        //initQuickApplyRecaptcha();

      }
    }
  }
}